import { CONTACT_ASSOCIATION_ID } from './../../../modules/shared/constants/typeId';
import { ParseHelper } from './../../../modules/shared/parse.helper';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AppMainComponent } from '../../../app.main.component';
import {
  ConfirmationService,
  ConfirmEventType,
  MessageService,
} from 'primeng/api';
import { Status } from '../../../models/statusEnums';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { AppMainService } from '../../../app-main.service';
import { uploadFiles, validateFiles } from '../../../shared/upload-files';
import { saveAs } from 'file-saver';
import { LocalDatePipe } from '../../../shared/pipes/local-date.pipe';
import { emailValidator } from './../../../modules/shared/validators/email.validator';
import { ContactService } from 'src/app/contacts/contactService';
import { AccountContact } from '../../model/accountContact';
import { Contact } from 'src/app/accounts/model/contact';
import { ContactSpokenLanguage } from 'src/app/shared/model/models';
import { LeadService } from '../../leadService';
import { catchError, map, takeUntil, tap } from 'rxjs/operators';
import { SharedCRMConfigService } from 'src/app/configurations/crm/shared/services/shared-crm-config.service';
import { LeadModuleId} from 'src/app/modules/shared/constants/modules.constant';
import { TemplateSection } from 'src/app/modules/shared/model/templateSection.model';
import { of, Subject } from 'rxjs';
import { Sections } from '../../leads.constants';
import { LeadHelper } from '../../services/lead.helper';
import { Stage } from 'src/app/cases/model/stage';
import {
  CUSTOMFIELD_TYPE_IDS,
  EMAIL_TYPE_IDS,
  PHONE_TYPE_IDS,
  SOCIAL_PROFILE_TYPE_IDS,
} from 'src/app/modules/shared/constants/typeId';
import { ObjectNames } from 'src/app/modules/shared/constants/object.names';
import { CustomAttributeService } from 'src/app/modules/shared/services/custom-attribute.service';
import { generateContactName } from '../../../modules/shared/helpers/generate-contact-name.helper';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { ContactHttpService } from 'src/app/modules/shared/services/contact.http.service';
import {
  StatusGroupIds,
  TypeGroupIds,
} from 'src/app/modules/shared/constants/category-groupid.constants';
import { Lead } from '../../model/models';
import { PermissionService } from 'src/app/service/permission.service';
import { AppRuleSelectionService } from 'src/app/modules/shared/components/rule-selection/app.rule.selection.service';
import { SharedDataService } from 'src/app/modules/shared/stores/sharedDataStore/sharedData.service';
import { AccountLeadDataService } from 'src/app/modules/shared/stores/accountLeadDataStore/accountLeadData.service';
import { Tag } from 'src/app/accounts-v2/models/tag.model';
import { LeadServiceN } from '../../services/lead.service';
import { CrmSettingModel } from 'src/app/configurations/models/organization-settings.model';
import { UserService } from 'src/app/service/userservice';
import { CrmSettingsService } from 'src/app/modules/shared/services/crm-settings.service';
import { StageOnwerSettingCode } from 'src/app/modules/shared/constants/stage-owner-setting.constants';
import { AccountUserService } from 'src/app/service/account.service';
import { PhoneNumberFormatService } from '../../../modules/shared/services/phone-number-format.service';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';
import { is } from 'date-fns/locale';

@Component({
  selector: 'app-add-update-view-lead',
  templateUrl: './add-update-view-lead.component.html',
  styleUrls: ['./add-update-view-lead.component.scss'],
  providers: [LocalDatePipe],
})
export class AddUpdateViewLeadComponent implements OnInit, OnChanges {
  @ViewChild('addAdddressFrm') addAdddressFrm: FormGroupDirective;
  @ViewChild('addAdddressTypeFrm') addAdddressTypeFrm: FormGroupDirective;

  @Input() selectedLeadId: number;
  @Input() selectedChannelId: number;
  @Input() displayLeadAddEditView: boolean = false;
  @Input() currentSelectedLeadChannelIdForCopy: any;
  @Input() currentStageForCopy: any = {};
  @Input() crudType: 'add' | 'update' | 'view' | 'copy' | '' = ''; //values: add, update, view, Convert
  leadOwnerSettings: CrmSettingModel;
  channelWiseStages: any[] = [];
  @Output() cancelClicked = new EventEmitter();
  @Output() onComplete = new EventEmitter();

  leadForm: FormGroup;
  data: any;
  countryData: any;
  phoneNumberFormat: any = "(999) 999-9999";
  leadSequenceNumberServiceResponse: any;
  currentDisplay = false;
  headerTitle: string = '';
  displayAddressAdd = false;
  addressHeader: string = '';
  editPermission = false;

  detailsLoadingFailed: boolean = false;
  detailsErrorMessage: string = '';

  isEditAccount = true;
  statusEnum = Status;
  isAdd = true;
  allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif']; // For the attachment files
  selectedcontactProfileImages: any[] = [];
  selectedcontactBusinessCards: any[] = [];
  contactAttachments = {
    id: 0,
    createdSource: this.app.userIP,
    updatedSource: this.app.userIP,
    createdBy: this.app.user.userId,
    updatedBy: this.app.user.userId,
    createdDate: new Date(),
    updatedDate: new Date(),
    contactId: 0,
    attachmentId: 0,
    attachment: {
      id: 0,
      createdSource: 'string',
      updatedSource: 'string',
      createdBy: this.app.user.userId,
      updatedBy: 0,
      createdDate: new Date(),
      updatedDate: new Date(),
      name: 'string',
      guidName: 'string',
      location: 'string',
      content: 'string',
      extension: 'string',
      sizeInBytes: 0,
      description: 'string',
      statusId: 0,
      isValid: true,
      validFromDate: '2021-04-03T14:18:49.091Z',
      validToDate: '2021-04-03T14:18:49.091Z',
    },
  };
  mimeTypes = [
    { extension: 'gif', value: 'image/gif;charset=utf-8' },
    { extension: 'jpeg', value: 'image/jpeg;charset=utf-8' },
    { extension: 'jpg', value: 'image/jpeg;charset=utf-8' },
    { extension: 'png', value: 'image/png;charset=utf-8' },
  ];
  selectedAccount;
  selectedLead;

  accountTempAddress: any[] = [];
  contactListAttn: Array<Contact> = [];
  showLeadInfoMore: boolean = false;
  isSubmitted: boolean = false;
  storedAccountEmails: any[] = [];
  storedAccountPhones: any[] = [];
  storedAccountSocials: any[] = [];
  // channel;
  selectedStatus = false;
  //sequenceNumber
  isSequenceNumberFeild: boolean;
  generateSequenceSeriesNumber: string;

  isEditPermission: boolean = false;
  accountContact;
  accountAddress;
  stages: Stage[] = [];
  selectedStage: Stage;
  activeUsers: any = [];
  contactRoles: any[] = []; //for contact Desgination 
  newContactRoles: any[] = []; //for contact roles new field added
  types: any[] = [];
  salutations: any[] = [];
  selectedContactAssociationType;
  timeZoneList: Array<any> = [];
  currencyList: Array<any> = [];
  activeCurrencies: Array<any> = [];
  
  employees: any[] = [];
  revenues: any[] = [];
  ownerships: any[] = [];
  industries: any[] = [];
  sources: any[] = [];
  ratings: any[] = [];
  accountAddressTypes: Array<any> = [];
  addressClasses: Array<any> = [];
  status: any[] = [];
  countries: any[] = [];

  objectId: number = LeadModuleId;

  // Default DD Values
  defaultSalutation;
  defaultContactRole;
  defaultNewContactRole;
  defaultLeadType;
  defaultLeadSource;
  defaultRating;
  defaultEmployeesCount;
  defaultRevenue;
  defaultOwnership;
  defaultIndustry;

  leadModuleId = LeadModuleId;

  templateSections: TemplateSection[] = [];
  checkedFields: any = {};

  // Custom Attributes
  leadInfoCustomFields = [];
  leadInfoCustomValues = [];
  leadDetailsCustomFields = [];
  leadDetailsCustomValues = [];

  // Emails, Phones, Socials IDs
  emailIds = EMAIL_TYPE_IDS;
  phoneIds = PHONE_TYPE_IDS;
  socialIds = SOCIAL_PROFILE_TYPE_IDS;
  customFieldIds = CUSTOMFIELD_TYPE_IDS;

  // Contact Emails
  contactEmails = [];
  workEmail: any = {
    email: {},
  };
  homeEmail: any = {
    email: {},
  };
  ce1: any = {
    email: {},
  };
  ce2: any = {
    email: {},
  };

  // Contact Phones
  contactPhones = [];
  workPhone: any = {
    phone: {},
  };
  homePhone: any = {
    phone: {},
  };
  mobilePhone: any = {
    phone: {},
  };
  cp1: any = {
    phone: {},
  };
  cp2: any = {
    phone: {},
  };

  // Contact Socials
  contactSocials = [];
  contactFacebook: any = {
    socialProfile: {},
  };
  contactTwitter: any = {
    socialProfile: {},
  };
  contactLinkedin: any = {
    socialProfile: {},
  };
  contactInstagram: any = {
    socialProfile: {},
  };
  contactWebsite: any = {
    socialProfile: {},
  };

  // Lead Emails
  leadEmails = [];

  // Lead Phones
  leadPhones = [];

  // Lead Socials
  leadSocials = [];
  leadFacebook: any = {
    socialProfile: {},
  };
  leadTwitter: any = {
    socialProfile: {},
  };
  leadLinkedin: any = {
    socialProfile: {},
  };
  leadInstagram: any = {
    socialProfile: {},
  };
  leadWebsite: any = {
    socialProfile: {},
  };

  tabIndex = 0;
  viewLeadData = {};

  //communication
  selectedCommunication: string[] = [];

  // Subject to unsubscribe
  private ngUnsubscribe = new Subject<void>();
  //tags
  tags: Tag[] = [];
  isEditTag = false;
  displayAddTag = false;
  tempTag: Tag = { id: 0, name: '', color: '#000000' };
  tagList: Tag[] = [];
  selectedValues: any[] = [];
  pageSize: number = 5;
  first: number = 0;
  displayCreateTag: boolean = false;

  /** Custom Section */
  customSections: TemplateSection[] = [];
  customSectionsForView: TemplateSection[] = [];
  customSectionFields = [];
  customSectionValues = [];
  ownerList: any[] = [];
  stageCommentEnable: boolean = false;
  selectedOwnerStageDefault: any;
  selectedOwnerStage: any;
  constructor(
    public app: AppMainComponent,
    public FormBuilder: FormBuilder,
    public appMainService: AppMainService,
    private messageService: MessageService,
    private contactService: ContactService,
    public localDatePipe: LocalDatePipe,
    private leadService: LeadService,
    private leadHelper: LeadHelper,
    public confirmationService: ConfirmationService,
    private customAttributeService: CustomAttributeService,
    private sharedConfigService: SharedCRMConfigService,
    private configurationService: ConfigurationService,
    private contactHttpService: ContactHttpService,
    private permissionService: PermissionService,
    private ruleService: AppRuleSelectionService,
    private sharedDataService: SharedDataService,
    private accountDataService: AccountLeadDataService,
    private leadServiceN: LeadServiceN,
    public userService: UserService,
    private crmSettingsService: CrmSettingsService,
    private accountUserService: AccountUserService,
    private phoneNumberFormatService: PhoneNumberFormatService,
    private importService: ImportserialService, 
  ) { }

  async ngOnInit() {
    this.getCountryCode();
    this.getPhoneNumberTemplate();
    const userPermissions = this.permissionService.getPemrissionData();
    if (userPermissions.length) {
      let leadUserPermission = userPermissions.find(
        (obj) => obj.objectName === ObjectNames.LEAD
      );
      leadUserPermission = leadUserPermission.permissions.sort((a, b) =>
        a.permissionId < b.permissionId ? -1 : 1
      );
      this.editPermission =
        leadUserPermission &&
          leadUserPermission[2].permissionId == 3 &&
          leadUserPermission[2].statusId == 1
          ? true
          : false;
    }

    if (this.crudType == 'copy') {
      this.selectedChannelId = this.currentSelectedLeadChannelIdForCopy;
    }

    await this.showEditLead();
    this.getTemplateFormFields(this.selectedChannelId);
  }

  preLeadpareCrud() {
    // this.getSettingsData();
    this._updateCrudStateData();
    this.generateContactEmails();
    this.generateContactPhones();
    this.generateContactSocials();
    this.generateLeadEmails();
    this.generateLeadPhones();
    this.generateLeadSocials();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.currentSelectedLeadChannelIdForCopy?.currentValue) {
      this.currentSelectedLeadChannelIdForCopy =
        changes.currentSelectedLeadChannelIdForCopy.currentValue;
    }

    if (changes.currentStageForCopy?.currentValue) {
      this.currentStageForCopy = changes.currentStageForCopy.currentValue;
    }

  }

  generateContactEmails() {
    const model = {
      // accountId: this.selectedAccount.id,
      contactId: this.selectedLead?.leadContacts?.length
        ? this.selectedLead?.leadContacts[0]?.contact?.id
        : 0,
      emailId: 0,
      id: 0,
      tempValue: '',
      updatedBy: null,
      updatedDate: null,
      updatedSource: null,
      email: {
        emailType: null,
        name: '',
        description: '',
        emailTypeId: 0,
        id: 0,
        status: null,
        statusId: 1,
        updatedBy: null,
        updatedDate: null,
        updatedSource: null,
      },
    };

    const contactEmails = this.selectedLead?.leadContacts?.length
      ? this.selectedLead.leadContacts[0]?.contact?.contactEmails
      : [];

    // Work Email
    const foundWorkEmail = contactEmails?.find(
      (el) => el.email.emailTypeId === this.emailIds.WORK
    );

    if (foundWorkEmail) {
      this.workEmail = foundWorkEmail;
      this.workEmail['tempValue'] = ParseHelper.DeepCopy(
        this.workEmail.email.emailAddress
      );
    } else {
      this.workEmail = JSON.parse(JSON.stringify(model));
      this.workEmail.email.emailTypeId = this.emailIds.WORK;
    }

    // Home Email
    const foundHomeEmail = contactEmails?.find(
      (el) => el.email.emailTypeId === this.emailIds.HOME
    );

    if (foundHomeEmail) {
      this.homeEmail = foundHomeEmail;
      this.homeEmail['tempValue'] = ParseHelper.DeepCopy(
        this.homeEmail.email.emailAddress
      );
    } else {
      this.homeEmail = JSON.parse(JSON.stringify(model));
      this.homeEmail.email.emailTypeId = this.emailIds.HOME;
    }

    // CE1
    const foundCE1 = contactEmails?.find(
      (el) => el.email.emailTypeId === this.emailIds.CE1
    );

    if (foundCE1) {
      this.ce1 = foundCE1;
      this.ce1['tempValue'] = ParseHelper.DeepCopy(this.ce1.email.emailAddress);
    } else {
      this.ce1 = JSON.parse(JSON.stringify(model));
      this.ce1.email.emailTypeId = this.emailIds.CE1;
    }

    // CE2
    const foundCE2 = contactEmails?.find(
      (el) => el.email.emailTypeId === this.emailIds.CE2
    );

    if (foundCE2) {
      this.ce2 = foundCE2;
      this.ce2['tempValue'] = ParseHelper.DeepCopy(this.ce2.email.emailAddress);
    } else {
      this.ce2 = JSON.parse(JSON.stringify(model));
      this.ce2.email.emailTypeId = this.emailIds.CE2;
    }
  }

  generateContactPhones() {

    const defaultCountry = this.app.userDetails?.locations?.[0]?.address?.country?.name || this.app.organizationData?.address?.country?.name;
    const defaultCode = this.app.userDetails?.locations?.[0]?.address?.country?.phoneCode || this.app.organizationData?.address?.country?.phoneCode;

    const model = {
      // accountId: this.selectedAccount.id,
      contactId: this.selectedLead?.leadContacts?.length
        ? this.selectedLead?.leadContacts[0]?.contact?.id
        : 0,
      phoneId: 0,
      id: 0,
      tempValue: '',
      updatedBy: null,
      updatedDate: null,
      updatedSource: null,
      phone: {
        phoneType: null,
        country: defaultCountry,
        code: defaultCode,
        number: '',
        description: '',
        phoneTypeId: 0,
        id: 0,
        status: null,
        statusId: 1,
        updatedBy: null,
        updatedDate: null,
        updatedSource: null,
      },
    };

    const contactPhones = this.selectedLead?.leadContacts?.length
      ? this.selectedLead.leadContacts[0]?.contact?.contactPhones
      : [];

    // Work Phone
    const foundWorkPhone = contactPhones?.find(
      (el) => el.phone.phoneTypeId === this.phoneIds.WORK
    );

    if (foundWorkPhone) {
      this.workPhone = foundWorkPhone;
      this.workPhone.phone.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(this.workPhone.phone.number);
      this.workPhone['tempValue'] = ParseHelper.DeepCopy(
        this.workPhone.phone.number
      );
    } else {
      this.workPhone = JSON.parse(JSON.stringify(model));
      this.workPhone.phone.phoneTypeId = this.phoneIds.WORK;
    }

    // Home Phone
    const foundHomePhone = contactPhones?.find(
      (el) => el.phone.phoneTypeId === this.phoneIds.HOME
    );

    if (foundHomePhone) {
      this.homePhone = foundHomePhone;
      this.homePhone.phone.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(this.homePhone.phone.number);
      this.homePhone['tempValue'] = ParseHelper.DeepCopy(
        this.homePhone.phone.number
      );
    } else {
      this.homePhone = JSON.parse(JSON.stringify(model));
      this.homePhone.phone.phoneTypeId = this.phoneIds.HOME;
    }

    // Mobile Phone
    const foundMobilePhone = contactPhones?.find(
      (el) => el.phone.phoneTypeId === this.phoneIds.MOBILE
    );

    if (foundMobilePhone) {
      this.mobilePhone = foundMobilePhone;
      this.mobilePhone.phone.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(this.mobilePhone.phone.number);
      this.mobilePhone['tempValue'] = ParseHelper.DeepCopy(
        this.mobilePhone.phone.number
      );
    } else {
      this.mobilePhone = JSON.parse(JSON.stringify(model));
      this.mobilePhone.phone.phoneTypeId = this.phoneIds.MOBILE;
    }

    // CP1
    const foundCP1 = contactPhones?.find(
      (el) => el.phone.phoneTypeId === this.phoneIds.CP1
    );

    if (foundCP1) {
      this.cp1 = foundCP1;
      this.cp1.phone.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(this.cp1.phone.number);
      this.cp1['tempValue'] = ParseHelper.DeepCopy(this.cp1.phone.number);
    } else {
      this.cp1 = JSON.parse(JSON.stringify(model));
      this.cp1.phone.phoneTypeId = this.phoneIds.CP1;
    }

    // CP2
    const foundCP2 = contactPhones?.find(
      (el) => el.phone.phoneTypeId === this.phoneIds.CP2
    );

    if (foundCP2) {
      this.cp2 = foundCP2;
      this.cp2.phone.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(this.cp2.phone.number);
      this.cp2['tempValue'] = ParseHelper.DeepCopy(this.cp2.phone.number);
    } else {
      this.cp2 = JSON.parse(JSON.stringify(model));
      this.cp2.phone.phoneTypeId = this.phoneIds.CP2;
    }
  }

  generateContactSocials() {
    const model = {
      // accountId: this.selectedAccount.id,
      contactId: this.selectedLead?.leadContacts?.length
        ? this.selectedLead?.leadContacts[0]?.contact?.id
        : 0,
      socialProfileId: 0,
      id: 0,
      tempValue: '',
      updatedBy: null,
      updatedDate: null,
      updatedSource: null,
      socialProfile: {
        socialProfileType: null,
        name: '',
        description: '',
        socialProfileTypeId: 0,
        id: 0,
        status: null,
        statusId: 1,
        updatedBy: null,
        updatedDate: null,
        updatedSource: null,
      },
    };

    const contactSocials = this.selectedLead?.leadContacts?.length
      ? this.selectedLead.leadContacts[0]?.contact?.contactSocialProfiles
      : [];

    // Facebook
    const foundFacebook = contactSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds.FACEBOOK
    );

    if (foundFacebook) {
      this.contactFacebook = foundFacebook;
      this.contactFacebook['tempValue'] = ParseHelper.DeepCopy(
        this.contactFacebook.socialProfile.name
      );
    } else {
      this.contactFacebook = JSON.parse(JSON.stringify(model));
      this.contactFacebook.socialProfile.socialProfileTypeId =
        this.socialIds.FACEBOOK;
    }

    // Twitter
    const foundTwitter = contactSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds.TWITTER
    );

    if (foundTwitter) {
      this.contactTwitter = foundTwitter;
      this.contactTwitter['tempValue'] = ParseHelper.DeepCopy(
        this.contactTwitter.socialProfile.name
      );
    } else {
      this.contactTwitter = JSON.parse(JSON.stringify(model));
      this.contactTwitter.socialProfile.socialProfileTypeId =
        this.socialIds.TWITTER;
    }

    // Linked In
    const foundLinkedIn = contactSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds.LINKEDIN
    );

    if (foundLinkedIn) {
      this.contactLinkedin = foundLinkedIn;
      this.contactLinkedin['tempValue'] = ParseHelper.DeepCopy(
        this.contactLinkedin.socialProfile.name
      );
    } else {
      this.contactLinkedin = JSON.parse(JSON.stringify(model));
      this.contactLinkedin.socialProfile.socialProfileTypeId =
        this.socialIds.LINKEDIN;
    }

    // Instagram
    const foundInstagram = contactSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds.INSTAGRAM
    );

    if (foundInstagram) {
      this.contactInstagram = foundInstagram;
      this.contactInstagram['tempValue'] = ParseHelper.DeepCopy(
        this.contactInstagram.socialProfile.name
      );
    } else {
      this.contactInstagram = JSON.parse(JSON.stringify(model));
      this.contactInstagram.socialProfile.socialProfileTypeId =
        this.socialIds.INSTAGRAM;
    }

    // Website
    const foundWebsite = contactSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds.WEBSITE
    );

    if (foundWebsite) {
      this.contactWebsite = foundWebsite;
      this.contactWebsite['tempValue'] = ParseHelper.DeepCopy(
        this.contactWebsite.socialProfile.name
      );
    } else {
      this.contactWebsite = model;
      this.contactWebsite.socialProfile.socialProfileTypeId =
        this.socialIds.WEBSITE;
    }
  }

  generateLeadEmails() {
    this.selectedLead.leadEmails =
      this.selectedLead?.leadEmails?.filter((el) => el.email) || [];

    if (this.selectedLead?.leadEmails?.length) {
      this.leadEmails = [this.selectedLead.leadEmails[0]];
    } else {
      this.leadEmails = [
        {
          leadId: this.selectedLead?.id || 0,
          emailId: 0,
          emailTypeId: this.emailIds.WORK,
          id: 0,
          updatedBy: null,
          updatedDate: null,
          updatedSource: null,
          email: {
            description: '',
            emailAddress: '',
            emailType: null,
            emailTypeId: this.emailIds.WORK,
            id: 0,
            status: null,
            statusId: 1,
            updatedBy: null,
            updatedDate: null,
            updatedSource: null,
          },
        },
      ];
    }
  }

  generateLeadPhones() {

    const defaultCountry = this.app.userDetails?.locations?.[0]?.address?.country?.name || this.app.organizationData?.address?.country?.name;
    const defaultCode = this.app.userDetails?.locations?.[0]?.address?.country?.phoneCode || this.app.organizationData?.address?.country?.phoneCode;

    this.selectedLead.leadPhones = this.selectedLead?.leadPhones?.filter((el) => el.phone) || [];

    if (this.selectedLead?.leadPhones?.length) {
      this.leadPhones = [this.selectedLead.leadPhones[0]];
      this.leadPhones[0].phone.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(this.leadPhones[0].phone.number)
    } else {
      this.leadPhones = [
        {
          leadId: this.selectedLead?.id || 0,
          phoneId: 0,
          id: 0,
          updatedBy: null,
          updatedDate: null,
          updatedSource: null,
          phoneTypeId: this.phoneIds.WORK,
          phone: {
            country: defaultCountry,
            code: defaultCode,
            number: '',
            extension: '',
            phoneTypeId: this.phoneIds.WORK,
            id: 0,
            status: null,
            statusId: 1,
            updatedBy: null,
            updatedDate: null,
            updatedSource: null,
          },
        },
      ];
    }
  }

  generateLeadSocials() {
    const model = {
      leadId: this.selectedLead?.id || 0,
      socialProfileId: 0,
      id: 0,
      updatedBy: null,
      updatedDate: null,
      updatedSource: null,
      socialProfile: {
        socialProfileType: null,
        name: '',
        description: '',
        socialProfileTypeId: 0,
        id: 0,
        status: null,
        statusId: 1,
        updatedBy: null,
        updatedDate: null,
        updatedSource: null,
      },
    };

    const leadSocials = this.selectedLead.leadSocials;

    // Facebook
    const foundFacebook = leadSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds.FACEBOOK
    );

    if (foundFacebook) {
      this.leadFacebook = foundFacebook;
    } else {
      this.leadFacebook = JSON.parse(JSON.stringify(model));
      this.leadFacebook.socialProfile.socialProfileTypeId =
        this.socialIds.FACEBOOK;
    }

    // Twitter
    const foundTwitter = leadSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds.TWITTER
    );

    if (foundTwitter) {
      this.leadTwitter = foundTwitter;
    } else {
      this.leadTwitter = JSON.parse(JSON.stringify(model));
      this.leadTwitter.socialProfile.socialProfileTypeId =
        this.socialIds.TWITTER;
    }

    // Linked In
    const foundLinkedIn = leadSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds.LINKEDIN
    );

    if (foundLinkedIn) {
      this.leadLinkedin = foundLinkedIn;
    } else {
      this.leadLinkedin = JSON.parse(JSON.stringify(model));
      this.leadLinkedin.socialProfile.socialProfileTypeId =
        this.socialIds.LINKEDIN;
    }

    // Instagram
    const foundInstagram = leadSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds.INSTAGRAM
    );

    if (foundInstagram) {
      this.leadInstagram = foundInstagram;
    } else {
      this.leadInstagram = JSON.parse(JSON.stringify(model));
      this.leadInstagram.socialProfile.socialProfileTypeId =
        this.socialIds.INSTAGRAM;
    }

    // Website
    const foundWebsite = leadSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds.WEBSITE
    );

    if (foundWebsite) {
      this.leadWebsite = foundWebsite;
    } else {
      this.leadWebsite = model;
      this.leadWebsite.socialProfile.socialProfileTypeId =
        this.socialIds.WEBSITE;
    }
  }

  populateDefaultData() {
    this.populateSalutations();
    this.populateCurrency();
    this.populateContactRoles();
    this.populateLeadTypes();
    this.populateLeadSource();
    this.populateRating();
    this.populateEmployees();
    this.populateAnnualRevenue();
    this.populateOwnershipTypes();
    this.populateIndustry();
    this.populateLeadStages();
    this.populateNewContactRoles();
  }

  populateSalutations() {
    if (this.crudType === 'add') {
      this.defaultSalutation = this.salutations.find((el) => el.isDefault);
      const itemControls = <FormArray>this.leadForm?.controls['leadContacts'];
      const itemFormGroup = <FormGroup>itemControls?.controls[0];
      const contactGroup = <FormGroup>itemFormGroup?.controls['contact'];
      contactGroup?.controls['salutationId']?.setValue(
        this.defaultSalutation?.id
      );
    }
  }
  
  populateCurrency() {
    if (this.crudType === 'add') {
      let defaultCurrency = this.activeCurrencies.find(currency => currency?.isBaseCurrency) || {};
      if (defaultCurrency) {
        defaultCurrency = {
          id: defaultCurrency?.currencyId,
          name: `${defaultCurrency?.code} - ${defaultCurrency?.country?.name}`,
        };
        this.leadForm?.patchValue({ currencyId: defaultCurrency });
      }
    }
  }

  populateLeadStages() {
    if (this.crudType === 'add' && this.selectedStage) {
      this.leadForm?.patchValue({
        leadStage: this.selectedStage,
        leadStageId: this.selectedStage?.id,
      });
    }
  }

  populateContactRoles() {
    if (this.crudType === 'add') {
      this.defaultContactRole = this.contactRoles.find((el) => el.isDefault);
      const itemControls = <FormArray>this.leadForm?.controls['leadContacts'];
      const itemFormGroup = <FormGroup>itemControls?.controls[0];
      const contactGroup = <FormGroup>itemFormGroup?.controls['contact'];
      contactGroup?.controls['contactRoleId']?.setValue(
        this.defaultContactRole?.id||null
      );
    }
  }

  populateLeadTypes() {
    if (this.crudType === 'add') {
      this.defaultLeadType = this.types.filter((el) => el.isDefault);
      this.leadForm?.patchValue({ selectedLeadTypes: this.defaultLeadType });
    }
  }

  populateLeadSource() {
    if (this.crudType === 'add') {
      this.defaultLeadSource = this.sources?.find((el) => el.isDefault);
      this.leadForm?.patchValue({ sourceId: this.defaultLeadSource });
    }
  }

  populateRating() {
    if (this.crudType === 'add') {
      this.defaultRating = this.ratings?.find((el) => el.isDefault);
      this.leadForm?.patchValue({ ratingId: this.defaultRating });
    }
  }

  populateEmployees() {
    if (this.crudType === 'add') {
      this.defaultEmployeesCount = this.employees.find((el) => el.isDefault);
      this.leadForm?.patchValue({
        employeesRangeId: this.defaultEmployeesCount,
      });
    }
  }

  populateAnnualRevenue() {
    if (this.crudType === 'add') {
      this.defaultRevenue = this.revenues.find((el) => el.isDefault);
      this.leadForm?.patchValue({ annualRevenueId: this.defaultRevenue });
    }
  }

  populateOwnershipTypes() {
    if (this.crudType === 'add') {
      this.defaultOwnership = this.ownerships.find((el) => el.isDefault);
      this.leadForm?.patchValue({ ownerShipType: this.defaultOwnership });
    }
  }

  populateIndustry() {
    if (this.crudType === 'add') {
      this.defaultIndustry = this.industries.find((el) => el.isDefault);
      this.leadForm?.patchValue({ industry: this.defaultIndustry });
    }
  }

  showAddAccount() {
    this.currentDisplay = true;
    this.generateSequenceNumber();
    this.accountTempAddress = [];
    this.isEditAccount = true;
    this.contactListAttn = [];
    this.isAdd = true;
    this.selectedStatus = true;
    this.showLeadInfoMore = false;
    this.prepareLeadForm();
    this.populateDefaultData();
    this.leadForm?.patchValue({
      typeId: this.selectedChannelId,
    });
  }

  generateSequenceNumber() {
    this.configurationService
      .generateSequenceNumberByModuleId(this.leadModuleId)
      .subscribe((response) => {
        this.generateSequenceSeriesNumber = response;
        this.configurationService
          .sequenceNumberByModuleId(this.leadModuleId)
          .subscribe((res) => {
            this.data = res;
            if (
              this.data.enableAutoGeneration &&
              !this.data.enableManualEntry
            ) {
              this.isSequenceNumberFeild = true;
            } else {
              this.isSequenceNumberFeild = false;
            }
            if (this.data.enableAutoGeneration) {
              this.leadForm
                .get('sequenceNumber')
                .setValue(this.generateSequenceSeriesNumber);
            }
          });
      });
  }

  clearEmailPhoneSocialData() {
    // Contact Emails
    this.contactEmails = [];
    this.workEmail = {
      email: {},
    };
    this.homeEmail = {
      email: {},
    };
    this.ce1 = {
      email: {},
    };
    this.ce2 = {
      email: {},
    };

    // Contact Phones
    this.contactPhones = [];
    this.workPhone = {
      phone: {},
    };
    this.homePhone = {
      phone: {},
    };
    this.mobilePhone = {
      phone: {},
    };
    this.cp1 = {
      phone: {},
    };
    this.cp2 = {
      phone: {},
    };

    // Contact Socials
    this.contactSocials = [];
    this.contactFacebook = {
      socialProfile: {},
    };
    this.contactTwitter = {
      socialProfile: {},
    };
    this.contactLinkedin = {
      socialProfile: {},
    };
    this.contactInstagram = {
      socialProfile: {},
    };
    this.contactWebsite = {
      socialProfile: {},
    };

    // Lead Emails
    this.leadEmails = [];

    // Lead Phones
    this.leadPhones = [];

    // Lead Socials
    this.leadSocials = [];
    this.leadFacebook = {
      socialProfile: {},
    };
    this.leadTwitter = {
      socialProfile: {},
    };
    this.leadLinkedin = {
      socialProfile: {},
    };
    this.leadInstagram = {
      socialProfile: {},
    };
    this.leadWebsite = {
      socialProfile: {},
    };
  }

  setSelectedLeadDetails(lead) {
    this.contactListAttn = [];

    let contactName: string = '';

    if (lead.leadContacts && lead.leadContacts.length > 0) {
      const contactDetails = lead.leadContacts[0].contact;
      contactName = generateContactName(contactDetails);
    }

    const data = {
      ...lead,
      contactName: contactName,
      leadStatus: lead.leadStatus ? lead.leadStatus.name : '',
      leadTypesNames:
        lead.leadTypes && lead.leadTypes.length > 0
          ? this.getAccountNames(lead.leadTypes)
          : null,
      statusName: lead.status ? lead.status.name : null,
      phone:
        lead.leadPhones &&
        lead.leadPhones.length > 0 &&
        lead.leadPhones[0] &&
        lead.leadPhones[0].phoneNumber
          ? lead.leadPhones[0].phoneNumber
          : null,
    };
    data['createdDate'] = data['createdDate']
      ? this.localDatePipe.transform(data['createdDate'], 'date')
      : null;
    data['updatedDate'] = data['updatedDate']
      ? this.localDatePipe.transform(data['updatedDate'], 'date')
      : null;

    this.selectedAccount = data;

    if (
      this.selectedAccount &&
      this.selectedAccount.leadContacts &&
      this.selectedAccount.leadContacts.length
    ) {
      this.selectedAccount.leadContacts.forEach((element) => {
        let contactName: string = '';

        if (element?.contact) {
          const contactDetails = element.contact;
          contactName = generateContactName(contactDetails);
        }

        element['contactName'] = contactName;
      });
      this.contactListAttn = this.selectedAccount.leadContacts;
    }

    if (
      this.selectedAccount.leadAddresses &&
      this.selectedAccount.leadAddresses.length
    ) {
      this.accountTempAddress = this.selectedAccount.leadAddresses;
    }
  }

  showEditAccount() {

    if (!this.selectedLead) return;
    this.loadUsers();
    this.setSelectedLeadDetails(this.selectedLead);
    this.selectedStatus = this.selectedLead.statusId === 1;
    this.isAdd = false;

    this.leadForm = null;
    this.selectedAccount.leadContacts = this.selectedAccount.leadContacts || [];
    this.selectedAccount.leadContacts = this.sortContactAccordingToPrimary(
      this.selectedAccount.leadContacts
    );
    this.formatDataForCopy();

    this.prepareLeadForm(this.selectedAccount);
    if (this.selectedAccount?.tags?.length > 0) {
      this.tags = this.selectedAccount.tags;
    }
    if (
      this.selectedAccount &&
      this.selectedAccount.leadContacts &&
      this.selectedAccount.leadContacts.length > 0 &&
      this.selectedAccount.leadContacts[0].contact &&
      this.selectedAccount.leadContacts[0].contact.contactProfileImages
    ) {
      this.selectedcontactProfileImages =
        this.selectedAccount.leadContacts[0].contact.contactProfileImages.filter(
          (x) => x.attachment != null
        ) || [];
    }

    this.selectedcontactProfileImages.forEach((element) => {
      if (element.attachment && element.attachment.content) {
        const kept = element.attachment.content.split(',', 2);
        const elem = kept[1];
        element.attachment.content = `data:image/png;base64,` + elem;
      }
    });

    if (
      this.selectedAccount &&
      this.selectedAccount.leadContacts &&
      this.selectedAccount.leadContacts.length > 0 &&
      this.selectedAccount.leadContacts[0].contact &&
      this.selectedAccount.leadContacts[0].contact.contactBusinessCards
    ) {
      this.selectedcontactBusinessCards =
        this.selectedAccount.leadContacts[0].contact.contactBusinessCards?.filter(
          (x) => x.attachment != null
        ) || [];
    }

    this.selectedcontactBusinessCards.forEach((element) => {
      if (element.attachment && element.attachment.content) {
        const kept = element.attachment.content.split(',', 2);
        const elem = kept[1];
        element.attachment.content = `data:image/png;base64,` + elem;
      }
    });

    const temp = JSON.parse(JSON.stringify(this.selectedAccount));

    const { leadContacts = [], leadTypes } = temp;

    if (leadContacts[0]?.contact) {
      leadContacts[0].contact.dateOfBirth = new Date(
        leadContacts[0]?.contact?.dateOfBirth
      );
      leadContacts[0].contact.startDate = new Date(
        leadContacts[0]?.contact?.startDate
      );

      if (leadContacts[0]?.contact?.contactRoles.length) {
        leadContacts[0].contact.contactRoles =
          leadContacts[0]?.contact?.contactRoles.map((obj) => {
            return { id: obj.id, roleId: obj.roleId, roleName: obj.roleName , isDefault: obj.isDefault ?? false};
          }) || [];
      }
    }



    const selectedLeadTypes =
      leadTypes?.length > 0
        ? leadTypes.map((type) => {
            return { ...type, id: type.typeId };
          })
        : null;

    const owner = this.activeUsers.find(
      (user) => user.id === this.selectedAccount?.ownerId
    );
    const annualRevenue = this.selectedAccount?.annualRevenueId
      ? { id: this.selectedAccount?.annualRevenueId }
      : null;
    const employeesRange = this.selectedAccount?.employeesRangeId
      ? { id: this.selectedAccount?.employeesRangeId }
      : null;
    const rating = this.selectedAccount?.ratingId
      ? { id: this.selectedAccount?.ratingId }
      : null;
    const source = this.selectedAccount?.sourceId
      ? { id: this.selectedAccount?.sourceId }
      : null;
    const currency = this.selectedAccount?.currencyId
      ? { id: this.selectedAccount?.currencyId }
      : null;
    const ownerShipType = this.selectedAccount?.ownershipId
      ? { id: this.selectedAccount?.ownershipId }
      : null;

    this.leadForm?.patchValue({
      ...temp,
      ownerId: owner,
      annualRevenueId: annualRevenue,
      employeesRangeId: employeesRange,
      ratingId: rating,
      sourceId: source,
      currencyId: currency,
      ownerShipType: ownerShipType,
      selectedLeadTypes: selectedLeadTypes,
    });
  }

  formatDataForCopy() {
    if (this.crudType === 'copy') {
      this.selectedAccount.id = 0;
      this.selectedLead.id = 0;
      this.selectedAccount.typeId = this.currentSelectedLeadChannelIdForCopy;
      this.selectedAccount.leadStageId = this.currentStageForCopy?.id;
      this.selectedAccount.sequenceNumber = null;

      const createdUpdated = {
        createdSource: this.app.userIP,
        createdBy: this.app.user.userId,
        createdDate: new Date(),
        updatedSource: null,
        updatedBy: null,
        updatedDate: null,
      };

      //Custom Attributes Id Formatting
      this.selectedLead?.customAttributeValues?.map((customAttribute, i) => {
        customAttribute.id = 0;
        customAttribute.objectValue = 0;
        this.selectedLead.customAttributeValues[i] = {
          ...customAttribute,
          ...createdUpdated,
        };
      });

      //Custom Attributes Id Formatting End

      this.selectedAccount?.leadTypes?.map((items) => {
        items.leadId = 0;
        items.id = 0;
      });

      this.selectedAccount?.leadEmails?.map((items) => {
        items.leadId = 0;
        items.emailId = 0;
        items.id = 0;

        if (items.email) items.email.id = 0;
      });

      this.selectedAccount?.leadPhones?.map((items) => {
        items.id = 0;
        items.leadId = 0;
        items.phoneId = 0;

        if (items.phone) items.phone.id = 0;
      });

      this.selectedAccount?.leadSocials?.map((items) => {
        items.leadId = 0;
        items.socialProfileId = 0;
        items.id = 0;

        if (items.socialProfile) items.socialProfile.id = 0;
      });

      this.selectedAccount?.leadAddresses?.map((items, i) => {
        items.leadId = 0;
        items.id = 0;
        items.addressId = 0;
        items.address.id = 0;

        this.selectedAccount.leadAddresses[i] = {
          ...items,
          ...createdUpdated,
        };
      });

      //Contact id formatting
      const primaryContact = this.selectedAccount?.leadContacts?.[0];
      this.selectedAccount.leadContacts = primaryContact
        ? [primaryContact]
        : [];

      this.selectedAccount?.leadContacts?.map((contactDetails, i) => {
        contactDetails.leadId = 0;
        contactDetails.id = 0;
        contactDetails.contactId = 0;

        if (contactDetails?.contact) {
          contactDetails.contact.id = 0;
          contactDetails.contact.attnContactId = 0;

          contactDetails?.contact?.contactEmails?.map((items, j) => {
            items.contactId = 0;
            items.emailId = 0;
            items.id = 0;
            items.email.id = 0;
          });

          contactDetails?.contact?.contactPhones?.map((items, j) => {
            items.id = 0;
            items.contactId = 0;
            items.phoneId = 0;
            items.phone.id = 0;
          });

          contactDetails?.contact?.contactSocialProfiles?.map((items, j) => {
            items.contactId = 0;
            items.socialProfileId = 0;
            items.id = 0;
            items.socialProfile.id = 0;
          });

          contactDetails?.contact?.contactProfileImages?.map((items, j) => {
            items.contactId = 0;
            items.attachmentId = 0;
            items.id = 0;

            if (items?.attachment) items.attachment.id = 0;
          });

          contactDetails?.contact?.contactBusinessCards?.map((items, j) => {
            items.contactId = 0;
            items.id = 0;

            if (items?.attachment) items.attachment.id = 0;
          });
          contactDetails?.contact?.contactRoles?.map((items, j) => {
            items.id = 0;
          });

        }

        this.selectedAccount.leadContacts[i] = {
          ...contactDetails,
          ...createdUpdated,
        };
      });
      //Contact id formatting end
    }
  }

  sortContactAccordingToPrimary(leadContacts) {
    let sortedContacts =
      leadContacts?.length > 0
        ? leadContacts.sort(
            (a, b) => b.contact.isPrimaryContact - a.contact.isPrimaryContact
          )
        : [];
    return sortedContacts || [];
  }

  async showEditAccountFromView() {
    this.isEditAccount = true;
    this.crudType = 'update';
    this.leadForm?.enable();
    await this.showEditLead();
    this.generateLeadInfoCustomFields();
    this.generateLeadDetailsCustomFields();
    this.prepareCustomSectionFields();
  }

  getSelectedValues(data = [], options, key) {
    return data.reduce((previousType, current) => {
      const index = this.types.findIndex(
        (_details) => _details.id === current[key].id
      );
      if (index !== -1) {
        previousType.push(options[index]);
      }
      return previousType;
    }, []);
  }

  onChangeEmailType({ value: { id } }, formGroup: FormGroup) {
    this.onChangeContactInfoField(id, formGroup, 'email', 'emailTypeId');
  }

  onChangeContactInfoField(id, formGroup, key, keyId) {
    let data = {};
    if (!this.isAdd) {
      data = {
        updatedBy: this.app.user.organizationId,
        updatedDate: new Date(),
        updatedSource: this.app.userIP,
      };
    }
    formGroup.patchValue({
      [key]: {
        [keyId]: id,
        ...data,
      },
    });
  }

  active(type, item) {
    if (type === 'email') {
      item.email.statusId = Status.Active;
    } else if (type === 'phone') {
      item.phone.statusId = Status.Active;
    } else if (type === 'socialProfile') {
      item.socialProfile.statusId = Status.Active;
    }
  }

  inactive(type, item) {
    if (type === 'email') {
      item.email.statusId = Status.InActive;
    } else if (type === 'phone') {
      item.phone.statusId = Status.InActive;
    } else if (type === 'socialProfile') {
      item.socialProfile.statusId = Status.InActive;
    }
  }

  uploadProfilePic(files: File[]) {
    this.appMainService.isShowSpinner('upload');
    if (typeof Worker !== undefined) {
      for (let file of files) {
        let errors = validateFiles(file, 2, this.allowedExtensions);
        if (errors.length > 0) {
          for (let error of errors) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.fileName + ': ' + error.error,
            });
          }
          this.appMainService.isHideSpinner('upload');
        } else {
          uploadFiles(file, ({ name, content, size, extension }) => {
            let attachment = {
              id: 0,
              createdSource: this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.user.userId,
              updatedBy: 0,
              createdDate: new Date(),
              updatedDate: new Date(),
              name: name,
              guidName: 'string',
              location: 'string',
              content: content,
              extension: extension,
              sizeInBytes: size,
              description: 'string',
              statusId: Status.Active,
              isValid: true,
              validFromDate: null,
              validToDate: null,
            };

            this.contactAttachments = {
              id: 0,
              createdSource: this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.user.userId,
              updatedBy: this.app.user.userId,
              createdDate: new Date(),
              updatedDate: new Date(),
              contactId: 0,
              attachmentId: 0,
              attachment: attachment,
            };
            this.selectedcontactProfileImages.push(this.contactAttachments);
            this.appMainService.isHideSpinner('upload');
          });
        }
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail:
          'Please update the browser. Web Workers are not supported in the older versions of this browser.',
      });
    }
  }

  uploadBusinessCard(files: File[]) {
    this.appMainService.isShowSpinner('upload');
    if (typeof Worker !== undefined) {
      for (let file of files) {
        let errors = validateFiles(file, 2, this.allowedExtensions);
        if (errors.length > 0) {
          for (let error of errors) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.fileName + ': ' + error.error,
            });
          }
          this.appMainService.isHideSpinner('upload');
        } else {
          uploadFiles(file, ({ name, content, size, extension }) => {
            let attachment = {
              id: 0,
              createdSource: this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.user.userId,
              updatedBy: 0,
              createdDate: new Date(),
              updatedDate: new Date(),
              name: name,
              guidName: 'string',
              location: 'string',
              content: content,
              extension: extension,
              sizeInBytes: size,
              description: 'string',
              statusId: Status.Active,
              isValid: true,
              validFromDate: null,
              validToDate: null,
            };

            this.contactAttachments = {
              id: 0,
              createdSource: this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.user.userId,
              updatedBy: this.app.user.userId,
              createdDate: new Date(),
              updatedDate: new Date(),
              contactId: 0,
              attachmentId: 0,
              attachment: attachment,
            };
            this.selectedcontactBusinessCards.push(this.contactAttachments);
            this.appMainService.isHideSpinner('upload');
          });
        }
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail:
          'Please update the browser. Web Workers are not supported in the older versions of this browser.',
      });
    }
  }

  downloadFile(name: string, content: string, locationUrl: string) {
    let ext = name.substring(name.lastIndexOf('.') + 1);

    let mime_type = this.mimeTypes.filter((el) => el.extension === ext);
    if (mime_type.length > 0 && content) {
      const base64 = content;
      const mime = mime_type[0].value;
      const blob = this.dataURItoBlob(base64, mime);
      const file = new File([blob], name, { type: mime });
      saveAs(file, name);
    } else {
      window.open(locationUrl);
    }
  }

  dataURItoBlob(dataURI: string, mimeType: string) {
    const kept = dataURI.split(',', 2);
    const byteString = atob(kept[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: mimeType });
    return blob;
  }

  removeProfileImg(ind) {
    this.selectedcontactProfileImages[ind].attachment.statusId = Status.Deleted;
  }

  removeBusinessCard(ind) {
    if (this.selectedcontactBusinessCards[ind].attachment.id > 0) {
      this.selectedcontactBusinessCards[ind].attachment.statusId =
        Status.Deleted;
    } else {
      this.selectedcontactBusinessCards.splice(ind, 1);
    }
  }

  removeImg(index, field) {
    field.customeAttachment.splice(index, 1);
  }

  checkRequired(name, cf_list) {
    return cf_list.find((el) => el.name === name)?.isRequired || false;
  }

  onCustomUpload(event, field, type) {
    field.customeAttachment = field.customeAttachment || [];
    field['touched'] = true;

    for (let file of event.files) {
      let errors = [];
      this.appMainService.isShowSpinner('upload');
      if (type == 'image') {
        errors = validateFiles(file, 4, this.allowedExtensions);
      }
      if (errors.length > 0) {
        for (let error of errors) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error.fileName + ': ' + error.error,
          });
        }
        this.appMainService.isHideSpinner('upload');
      } else {
        uploadFiles(file, ({ name, content, size, extension }) => {
          let attachment = {
            name: name,
            content: content,
            extension: extension,
            sizeInBytes: size,
          };
          field.customeAttachment.push(attachment);
          this.appMainService.isHideSpinner('upload');
        });
      }
    }
  }

  onKeyUpEmail(event) {
    this.formControl?.contactEmailsArray
      ?.get('0')
      ?.get('email')
      ?.get('emailAddress')
      .setValue(event.target.value);
    if (event.key == 'Enter' || event.key == 'Tab') {
      this.checkClearBitEmail(event);
    }
  }

  checkClearBitEmail({ target: { value } }) {
    if (value !== '') {
      this.contactService
        .checkClearBitData(value)
        .then(({ person, company }) => {
          this.formControl.contact.patchValue({
            firstName: person && person.name ? person.name.givenName : '',
            lastName: person && person.name ? person.name.familyName : '',
            title: person && person.employment ? person.employment.title : '',
            contactPhones: [
              {
                phone: {
                  number:
                    company &&
                    company.site &&
                    company.site.phoneNumbers &&
                    company.site.phoneNumbers.length > 0
                      ? company.site.phoneNumbers[0]
                      : '',
                },
              },
            ],
          });

          let nameBusiness =
            person && person.employment && person.employment.name
              ? person.employment.name.businessName
              : '';
          if (nameBusiness && nameBusiness != '')
            this.leadForm?.patchValue({
              businessName: nameBusiness,
            });

          this.formControl.firstAddress &&
            this.formControl.firstAddress.patchValue({
              name: company ? company.location : '',
            });
        });
    }
  }

  onCancelAddEditView() {
    this.currentDisplay = false;
    this.selectedcontactProfileImages = [];
    this.selectedcontactBusinessCards = [];

    if (this.crudType === 'view') {
        this.app.getAllObjects();
    }

    this.cancelClicked.emit({});
  }

  verifyAndSubmitLead(data, type: 'save' | 'view') {
    this.showLeadInfoMore = true;
    this.isSubmitted = true;
    setTimeout(() => {
      this.onAddEditLead(data, type);
    }, 200);
  }

  onAddEditLead(data, type: 'save' | 'view') {
    if (!this.leadForm?.valid) {
      const invalid = [];
      const controls = this.leadForm.controls;

      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      invalid.length > 0 && this.leadForm.markAllAsTouched();
      this.leadForm.markAsDirty();
      setTimeout(() => {
        this.scrollToError();
      }, 200);
      return;
    }

    // Also check for custom attributes
    const invalidField = document.querySelector('.p-invalid');

    if (invalidField) {
        const classList = Array.from(invalidField.classList);
        const customFieldsError = classList.find(element => element.startsWith('custom-fields-error'));

        if (classList.includes('details-error')) {
            this.tabIndex = 1;
        } else if (customFieldsError) {
            const tabIndex = parseInt(customFieldsError.split('custom-fields-error-')?.[1]||'0');
            this.tabIndex = tabIndex;
        } else {
            this.tabIndex = 0;
        }

        setTimeout(() => {
            this.scrollTo(invalidField);
        }, 200);
        return;
    }

    let accountData = this.getPreparedData(
      this.app.copyObjectWithoutRefrence(data)
    );
    
    if (this.tags.length > 0) {
      accountData['tags'] = this.tags;
    }else{
      accountData['tags'] = [];
    }
    accountData['createdDate'] = this.selectedLead?.createdDate || new Date();

    if (
      accountData.leadContacts &&
      accountData.leadContacts.length > 0 &&
      accountData.leadContacts[0].contact.firstName &&
      !accountData.leadContacts[0].contact.lastName
    ) {
      accountData.leadContacts[0].contact.lastName =
        accountData.leadContacts[0].contact.firstName;
    }

    if (accountData.leadContacts[0].contact.dateOfBirth) {
      accountData.leadContacts[0].contact.dateOfBirth = null;
    }

    if (this.crudType === 'update') {
      if (accountData.leadContacts[0].contact?.contactRoles.length > 0) {
        const newContactRolesArray = [];
        
        // Process each selected role
        accountData.leadContacts[0].contact?.contactRoles.forEach(selectedRole => {
          // Try to find this role in the existing data
          const existingRole = this.selectedLead.leadContacts[0].contact.contactRoles.find(
            existingRole => existingRole.roleId === selectedRole.roleId
          );
          
          if (existingRole) {
            // If role exists in API data, use that object
            newContactRolesArray.push(existingRole);
          } else {
            // If role is new, create a new object with id: 0
            newContactRolesArray.push({
              contactId: this.selectedLead.leadContacts[0].contactId,
              roleId: selectedRole.roleId,
              statusId: 1,
              roleName: selectedRole.roleName,
              id: 0,
              createdSource: this.app.userIP,
              updatedSource: null,  
              createdBy: this.app.user.userId,
              updatedBy: null,
              createdDate: new Date(),
              updatedDate: null
            });
          }
        });
        
        // Now, handle unselected roles (mark with statusId 3)
        this.selectedLead.leadContacts[0].contact.contactRoles.forEach(existingRole => {
          // Check if this existing role is not in the selected roles
          const isRoleStillSelected = accountData.leadContacts[0].contact.contactRoles.some(
            selectedRole => selectedRole.roleId === existingRole.roleId
          );
          
          if (!isRoleStillSelected) {
            // This role was previously assigned but now unselected
            // Create a copy with statusId 3 and add to array
            const unselectedRole = {...existingRole, statusId: 3, updatedBy: this.app.user.userId, updatedDate: new Date(), updatedSource: this.app.userIP};
            newContactRolesArray.push(unselectedRole);
          }
        });
        
        // Update the contact roles in your payload
        accountData.leadContacts[0].contact.contactRoles = newContactRolesArray;
      }
    }

    if (
      this.selectedcontactProfileImages &&
      accountData.leadContacts &&
      accountData.leadContacts[0].contact
    ) {
      accountData.leadContacts[0].contact['contactProfileImages'] =
        this.app.copyObjectWithoutRefrence(this.selectedcontactProfileImages);
    }

    if (
      this.selectedcontactBusinessCards &&
      accountData.leadContacts &&
      accountData.leadContacts[0].contact
    ) {
      accountData.leadContacts[0].contact['contactBusinessCards'] =
        this.app.copyObjectWithoutRefrence(this.selectedcontactBusinessCards);
    }

    if (accountData.leadTypes && accountData.leadTypes.length > 0) {
      if (this.selectedAccount && this.selectedAccount.id) {
        accountData.leadTypes.forEach((eachType) => {
          eachType['leadId'] = this.selectedAccount.id || 0;
        });
      }
    }
    accountData.sequenceNumber =
      this.generateSequenceSeriesNumber ===
      accountData.sequenceNumber.replace(/\s/g, '')
        ? null
        : accountData.sequenceNumber.replace(/\s/g, '');
    accountData.leadAddresses = this.setLeadAddresses();
    accountData.statusId = this.selectedStatus ? 1 : 2;

    this.appMainService.isShowSpinner('Action Performed');

    if (this.isAdd || this.crudType === 'copy') {
      this.leadService
        .addLead(accountData, this.app.user.organizationId)
        .subscribe(
          (data) => {
            this.appMainService.isHideSpinner('Action Performed');
            if (this.generateSequenceSeriesNumber !== data.sequenceNumber) {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: `New Lead with Lead Id No ${data.sequenceNumber} is Added Sucessfully`,
              });
            } else if (this.crudType === 'copy') {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: `Lead Copied Sucessfully...`,
              });
            } else {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Lead Added Sucessfully...',
              });
            }

            this.clearStoredData();
            this.isEditAccount = false;
            this.selectedcontactProfileImages = [];
            this.selectedcontactBusinessCards = [];
            if (type == 'view') {
              this.selectedLeadId = data?.id;
              this.crudType = 'view';
              this.showEditLead();
              this.onComplete.emit(data);
            } else {
              this.onComplete.emit(data);
              this.onCancelAddEditView();
            }
            this.isSubmitted = false;
          },
          (err) => {
            this.appMainService.isHideSpinner('Action Performed');
            if (
              err.error &&
              err.error.Message &&
              err.error.Message === 'Duplicate Lead.'
            ) {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: err.error.Message,
              });
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error While Lead Add...',
              });
            }
            this.isSubmitted = false;
          }
        );
    } else {
      this.leadService
        .updateLead(accountData)
        .then((data) => {
          this.clearStoredData();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Lead Updated Sucessfully...',
          });
          this.isEditAccount = false;
          this.selectedcontactProfileImages = [];
          this.selectedcontactBusinessCards = [];
          if (type == 'view') {
            this.crudType = 'view';
            this.showEditLead();
            this.onComplete.emit(data);
          } else {
            this.onComplete.emit(data);
            this.onCancelAddEditView();
          }
          this.isSubmitted = false;
        })
        .catch((err) => {
          if (
            err.error &&
            err.error.Message &&
            err.error.Message === 'Duplicate Lead.'
          ) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: err.error.Message,
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error While Lead Update...',
            });
          }
          this.isSubmitted = false;
        })
        .finally(() => {
          this.appMainService.isHideSpinner('Action Performed');
        });
    }
  }

  onUpdateAddressList($event) {
    this.accountTempAddress = $event.addressList;
    this.accountTempAddress.sort(this.compare);
  }

  compare(a, b) {
    if (a.address.name < b.address.name) {
      return -1;
    }

    if (a.address.name > b.address.name) {
      return 1;
    }

    return 0;
  }

  getAccountNames(accountTypes) {
    let names = '';
    accountTypes.forEach((type) => {
      names = names + ' ' + type.type.name;
    });
    return names;
  }

  setLeadAddresses() {
    const addressArr: any[] = [];
    this.accountTempAddress.map((addressObj) => {
      addressArr.push({
        id: addressObj.id || 0,
        createdSource: addressObj.createdSource || this.app.userIP,
        createdBy: addressObj.createdBy || this.app.user.userId,
        createdDate: addressObj.createdDate || new Date(),
        leadId: addressObj.leadId || 0,
        addressId: addressObj.address?.id || 0, // need to change
        address: {
          id: addressObj.address?.id || 0,
          attnContactId: addressObj.address?.attnContactId || null,
          streetAddress1: addressObj.address?.streetAddress1 || '',
          streetAddress2: addressObj.address?.streetAddress2 || '',
          createdSource: addressObj.address?.createdSource || this.app.userIP,
          createdBy: addressObj.address?.createdBy || this.app.user.userId,
          createdDate: addressObj.address?.createdDate || new Date(),
          name:
            addressObj.address.addressType &&
            addressObj.address.addressType.name
              ? addressObj.address.addressType.name
              : addressObj.address?.name,
          description: addressObj.address?.description || '',
          latitude: addressObj.address?.latitude || null,
          longitude: addressObj.address?.longitude || null,
          cityId: addressObj.address?.city?.id || null,
          stateId: addressObj.address?.state?.id || null,
          countryId: addressObj.address?.country?.id || null,
          zipCode: addressObj.address?.zipCode || '',
          addressTypeId: addressObj.address?.addressType?.id || 0, // need to change
          addressClassId: addressObj.address?.addressClass?.id || 0,
          addressName: addressObj.address?.addressName || null,
          customAttributeValues:
            addressObj.address.customAttributeValues &&
            addressObj.address.customAttributeValues.length > 0
              ? addressObj.address.customAttributeValues
              : null,
          statusId:
            addressObj.address && addressObj.address.statusId
              ? addressObj.address.statusId
              : 2,
          updatedBy: addressObj.address?.updatedBy || null,
          updatedDate: addressObj.address?.updatedDate || null,
          updatedSource: addressObj.address?.updatedSource || null,
          isDefault: addressObj.address?.isDefault || false,
        },
        updatedBy: addressObj.updatedBy || null,
        updatedDate: addressObj.updatedDate || null,
        updatedSource: addressObj.updatedSource || null,
      });
    });
    return addressArr.length ? addressArr : null;
  }

  clearStoredData() {
    this.storedAccountEmails = [];
    this.storedAccountPhones = [];
    this.storedAccountSocials = [];
    this.selectedcontactProfileImages = [];
    this.selectedcontactBusinessCards = [];
  }

  getUpdateProperties() {
    return {
      updatedBy: this.app.userId,
      updatedDate: new Date().toISOString(),
      updatedSource: this.app.userIP,
    };
  }

  removePropertyFromObject(data, propArray) {
    const details = Object.keys(data).reduce((object, key) => {
      const index = propArray.findIndex((_data) => _data === key);
      if (index == -1) {
        object[key] = data[key];
      }
      return object;
    }, {});

    return details;
  }

  getLeadSocials({ leadSocials = [], id: leadId }): Array<AccountContact> {
    const _leadId = leadId || 0;
    const propToRemove = [
      'socialProfileType',
      'emailType',
      'status',
      'phoneType',
    ];
    const updateDetails = this.getUpdateProperties();

    if (
      this.storedAccountSocials &&
      this.storedAccountSocials.length > 0 &&
      leadSocials.length > 0
    ) {
      for (const stored of this.storedAccountSocials) {
        if (stored['socialProfile']) {
          let socialProfileTypeId = stored['socialProfile'].socialProfileTypeId
            ? stored['socialProfile'].socialProfileTypeId
            : 0;
          const getActualSocial = leadSocials.find(
            (el) =>
              el['socialProfile'].socialProfileType.id == socialProfileTypeId
          );
          const getActualSocialIndex = leadSocials.findIndex(
            (el) =>
              el['socialProfile'].socialProfileType.id == socialProfileTypeId
          );
          if (getActualSocial && getActualSocial['socialProfile'].name == '') {
            getActualSocial['socialProfile'].name =
              stored['socialProfile'].name;
            getActualSocial['socialProfile'].statusId = 3;
            leadSocials[getActualSocialIndex] = getActualSocial;
          }
        }
      }
    }

    // if empty value then remove
    leadSocials = leadSocials.filter((data) => {
      return (
        data.socialProfile?.socialProfileType?.id !== 0 &&
        data.socialProfile?.name !== ''
      );
    });
    // remove socialProfileType property
    leadSocials = leadSocials.map((data) => {
      data.leadId = data.leadId || _leadId;
      data.socialProfileId = data.socialProfile.id;
      data.socialProfile = this.removePropertyFromObject(
        data.socialProfile,
        propToRemove
      );
      data.updatedSource = updateDetails.updatedSource;
      return data;
    });

    leadSocials = leadSocials.length === 0 ? null : leadSocials;
    return leadSocials;
  }

  getLeadPhones({ leadPhones = [], id: leadId }): Array<AccountContact> {
    const _leadId = leadId || 0;
    const propToRemove = [
      'socialProfileType',
      'emailType',
      'status',
      'phoneType',
    ];
    const updateDetails = this.getUpdateProperties();

    if (
      this.storedAccountPhones &&
      this.storedAccountPhones.length > 0 &&
      leadPhones.length > 0
    ) {
      for (const stored of this.storedAccountPhones) {
        if (stored['phone']) {
          const getActualPhones = leadPhones.find(
            (el) => el['phone'].phoneType.id == stored['phone'].phoneTypeId
          );
          const getActualPhonesIndex = leadPhones.findIndex(
            (el) => el['phone'].phoneType.id == stored['phone'].phoneTypeId
          );
          if (getActualPhones && getActualPhones['phone'].number == '') {
            getActualPhones['phone'].number = stored['phone'].number;
            getActualPhones['phone'].statusId = 3;
            leadPhones[getActualPhonesIndex] = getActualPhones;
          }
        }
      }
    }

    // if empty value then remove
    leadPhones = leadPhones.filter((data) => {
      return data?.phone?.phoneType?.id !== 0 && data?.phone?.number !== '';
    });
    // remove phone Type
    leadPhones = leadPhones.map((data) => {
      data.phoneTypeId = data?.phone?.phoneType?.id;
      data.leadId = data.leadId || _leadId;
      data.phone = this.removePropertyFromObject(data.phone, propToRemove);
      data.updatedSource = updateDetails.updatedSource;
      return data;
    });

    leadPhones = leadPhones.length === 0 ? null : leadPhones;
    return leadPhones;
  }

  getLeadEmails({ leadEmails = [], id: leadId }): Array<AccountContact> {
    const _leadId = leadId || 0;
    const propToRemove = [
      'socialProfileType',
      'emailType',
      'status',
      'phoneType',
    ];
    const updateDetails = this.getUpdateProperties();
    if (
      this.storedAccountEmails &&
      this.storedAccountEmails.length > 0 &&
      leadEmails.length > 0
    ) {
      for (const stored of this.storedAccountEmails) {
        if (stored['email']) {
          let emailTypeId = 0;
          emailTypeId = stored['email'].emailTypeId
            ? stored['email'].emailTypeId
            : 0;
          const getActualEmail = leadEmails.find(
            (el) => el['email'].emailType.id == emailTypeId
          );
          const getActualEmailIndex = leadEmails.findIndex(
            (el) => el['email'].emailType.id == emailTypeId
          );
          if (getActualEmail && getActualEmail['email'].emailAddress == '') {
            getActualEmail['email'].emailAddress = stored['email'].emailAddress;
            getActualEmail['email'].statusId = 3;
            leadEmails[getActualEmailIndex] = getActualEmail;
          }
        }
      }
    }
    // if empty value then remove
    leadEmails = leadEmails.filter((data) => {
      return data.email?.emailType?.id !== 0 && data.email?.emailAddress !== '';
    });
    // remove email Type
    leadEmails = leadEmails.map((data) => {
      data.emailTypeId = data.email?.emailType?.id;
      data.leadId = data.leadId || _leadId;
      data.email = this.removePropertyFromObject(data.email, propToRemove);
      data.updatedSource = updateDetails.updatedSource;
      return data;
    });
    leadEmails = leadEmails.length === 0 ? null : leadEmails;
    return leadEmails;
  }

  //data prepare for save
  getPreparedData(data) {
    const updateDetails = (this.isAdd || this.crudType === 'copy') ? null : this.getUpdateProperties();

    let contactData =
      data.leadContacts && data.leadContacts.length > 0
        ? data.leadContacts[0].contact
        : null;

    if (contactData) {
      const { salutationId, firstName, middleName, lastName } = contactData;
      contactData.firstName = contactData.firstName?.trim() || '';
      contactData.middleName = contactData.middleName?.trim() || '';
      contactData.lastName = contactData.lastName?.trim() || '';

      let salutation =
        this.salutations && this.salutations.length
          ? this.salutations.find((x) => x.id == salutationId)
          : null;
      let title = salutation ? salutation.name : '';
      let businessNameFromContact = generateContactName(contactData);
      data.businessName =
        data.businessName && data.businessName.trim() != ''
          ? data.businessName?.trim()
          : businessNameFromContact;
    }

    if (data?.sourceId) {
      if (!this.sources.find((x) => x.id == data.sourceId?.id)) {
        data.sourceId = null;
      }
    }

    if (data?.industry?.id) {
      if (!this.industries.find((x) => x.id == data?.industry?.id)) {
        data.industry.id = null;
      }
    }

    // Lead Emails
    if (!this.leadEmails[0]?.email?.emailAddress?.length) {
      this.leadEmails = [];
    }

    // Lead Phones
    let leadPhone = [];
    if (this.leadPhones[0]?.phone?.number?.trim()?.length) {
        leadPhone = ParseHelper.DeepCopy(this.leadPhones);
        leadPhone[0].phone.number = `${leadPhone[0]?.phone?.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(leadPhone[0]?.phone?.number)}`
    }

    // Lead Socials
    this.leadSocials = [];

    if (this.leadFacebook?.socialProfile?.name?.length) {
      this.leadSocials.push(this.leadFacebook);
    }

    if (this.leadTwitter?.socialProfile?.name?.length) {
      this.leadSocials.push(this.leadTwitter);
    }

    if (this.leadLinkedin?.socialProfile?.name?.length) {
      this.leadSocials.push(this.leadLinkedin);
    }

    if (this.leadInstagram?.socialProfile?.name?.length) {
      this.leadSocials.push(this.leadInstagram);
    }

    if (this.leadWebsite?.socialProfile?.name?.length) {
      this.leadSocials.push(this.leadWebsite);
    }

    let customAttributeValues = this.getCustomAttributePayload();

    let response = {
      id: data?.id || 0,
      typeId: data.typeId || 0,
      sequenceNumber: data?.sequenceNumber || '', //newFeildSequenceNumberAdded
      description: data?.description || '',
      emailAddress: data?.emailAddress,
      ownerId: data?.ownerId?.id,
      assignedToUserId: data?.assignedToUserId || null,
      leadPhones: leadPhone,
      leadEmails: this.leadEmails,
      leadSocials: this.leadSocials,
      businessName: data?.businessName || '',
      leadNumber: data.leadNumber || '',
      currencyId: data?.currencyId?.id || null,
      timeZoneId: data?.timeZoneId || null,
      taxId: data?.taxId || null,
      ownershipId: data?.ownerShipType?.id || null,
      name: data?.name || data?.businessName,
      isConvertedToAccount: data.isConvertedToAccount || false,
      leadTypes:
        this.getLeadTypes(
          data.selectedLeadTypes,
          data.leadTypes,
          data.leadId
        ) || null,
      organizationId: data?.organizationId || this.app.user.organizationId,
      leadId: data?.leadId || null,
      doingBusinessAs: data?.doingBusinessAs || '',
      branchId: data?.branchId || '',
      sourceId: data?.sourceId?.id || null,
      paymentTerm: data?.paymentTerm || '',
      paymentMethod: data?.paymentMethod || '',
      storePicture: data?.storePicture || '',
      industryId: data?.industry?.id || null,
      annualRevenueId: data?.annualRevenueId?.id || null,
      ratingId: data?.ratingId?.id || null,
      employeesRangeId: data?.employeesRangeId?.id || null,
      tickerSymbol: data?.tickerSymbol || '',
      leadStageId: data?.leadStageId || null,
      stageOwnerId: data?.stageOwnerId || null,
      comment: data?.comment || null,
      stageName: data?.stageName || '',
      gstNo: data?.gstNo || '',
      panNo: data?.panNo || '',
      leadStatusId: data?.leadStatusId || null,
      totalBalance: data?.totalBalance || 0,
      stageColor: data?.stageColor || '',
      statusId: data?.statusId || 1,
      isValid: data?.isValid || true,
      validFrom: data?.validFrom || null,
      validTo: data?.validTo || null,
      websiteURL: data?.websiteURL || '',
      webTechnologies: data?.webTechnologies || '',
      facebookPage: data?.facebookPage || '',
      linkedinPage: data?.linkedinPage || '',
      twitterPage: data?.twitterPage || '',
      instagramPage: data?.instagramPage || '',
      sicCode: data?.sicCode || null,
      naicsCode: data?.naicsCode || null,
      foundedYear: data?.foundedYear || null,
      foundedYearId: data?.foundedYear?.id || null,
      leadAddresses: null,
      leadContacts: this.getLeadContacts(data),
      customAttributeValues,
      createdSource: data?.createdSource || this.app.userIP,
      createdBy: data?.createdBy || this.app.user.userId,
      number: data?.number || 0,
      updatedBy: updateDetails?.updatedBy || null,
      updatedDate: updateDetails?.updatedDate || null,
      updatedSource: updateDetails?.updatedSource || null,
    };

    return response;
  }

  checkCheckBoxValidation(field) {
    return (
      field.customAttribute?.isRequired &&
      !field.value?.filter((el) => el.checked)?.length
    );
  }

  getCustomAttributePayload() {
    const leadInfoCustomPayload =
      this.customAttributeService.setSectionCustomPayload(
        this.selectedLead,
        this.leadInfoCustomFields,
        LeadModuleId
      ) || [];
    const leadDetailsCustomPayload =
      this.customAttributeService.setSectionCustomPayload(
        this.selectedLead,
        this.leadDetailsCustomFields,
        LeadModuleId
      ) || [];

    /** Custom section */
    const customSectionPayload = this.customSectionFields?.map((row) => {
        if(row != null && row.length > 0){
          return this.customAttributeService.setSectionCustomPayload(this.selectedLead, row, LeadModuleId);
        }
    });
    const filteredCustomSection = customSectionPayload?.filter(item => item != null && item != undefined);
    const flattenedCustomSection = filteredCustomSection?.reduce((v, current) => v.concat(current), []);
    /** End Custom section */

    return [...leadInfoCustomPayload, ...leadDetailsCustomPayload,...flattenedCustomSection];
  }

  modifyCustumAttributes(data) {
    data.forEach((element) => {
      if (
        element['customAttribute'] &&
        element['customAttribute']['pickListValues']
      ) {
        element['customAttribute']['pickListValues'] = JSON.stringify(
          element['customAttribute']['pickListValues']
        );
      }
    });
    return data;
  }

  prepareContactSpokenLanguage(
    selectedContactSpokenLanguages,
    contactSpokenLanguages = [],
    contactId = 0
  ): Array<ContactSpokenLanguage> {
    contactSpokenLanguages = contactSpokenLanguages || [];
    selectedContactSpokenLanguages = selectedContactSpokenLanguages || [];
    return selectedContactSpokenLanguages.map((language) => {
      const index = contactSpokenLanguages.findIndex(
        (data) => data.language.id === language.id
      );
      if (index !== -1) {
        return {
          ...contactSpokenLanguages[index],
        };
      }
      return {
        id: 0,
        ContactId: contactId,
        statusId: language?.statusId || 1,
        LanguageId: language?.id || 0,
        Language: null,
        createdSource: language?.createdSource || this.app.userIP,
        createdBy: language?.createdBy || this.app.user.userId,
        createdDate: language?.createdDate || new Date(),
      };
    });
  }

  getAccountContactMapData(data: Contact) {
    let _data: Contact = {
      ...data,
      sourceId: data?.source?.id || null,
      contactAssociationTypeId: this.selectedContactAssociationType?.id || null,
      genderId: data?.gender?.id || null,
      degreeId: data?.degree?.id || null,
      fieldOfStudyId: data?.fieldOfStudy?.id || null,
      contactTypeId: data?.contactType?.id || null,
      relationshipStatusId: data?.relationshipStatus?.id || null,
      maritalStatusId: data?.maritalStatus?.id || null,
      annualIncomeId: data?.annualIncome?.id || null,
      assistantId: data?.assistant?.id || null,
      organizationId: data?.organizationId || this.app.user.organizationId,
      contactRoleId: data?.contactRoleId,
      contactSpokenLanguages:
        data?.contactSpokenLanguages?.length > 0
          ? this.prepareContactSpokenLanguage(
              data['selectedContactSpokenLanguages'],
              data?.contactSpokenLanguages,
              data?.id
            )
          : [],
      customAttributeValues:
        data.customAttributeValues && data.customAttributeValues.length > 0
          ? data.customAttributeValues
          : null,
    };
    const propToRemove = [
      'maritalStatus',
      'gender',
      'source',
      'annualIncome',
      'degree',
      'contactType',
      'relationshipStatus',
      'status',
      'fieldOfStudy',
      'assistant',
      'contactAssociationType',
    ];
    _data = this.removePropertyFromObject(_data, propToRemove);
    return _data;
  }

  getLeadContacts({ leadContacts = [], id: leadId }): Array<AccountContact> {
    if (!leadContacts[0]) {
      return;
    }

    const _leadId = leadId || 0;
    const propToRemove = [
      'socialProfileType',
      'emailType',
      'status',
      'phoneType',
    ];
    const updateDetails = this.getUpdateProperties();
    leadContacts = leadContacts.map((data: AccountContact) => {
      return {
        ...data,
        leadId: _leadId,
        contact: this.getAccountContactMapData(data.contact),
      };
    });
    leadContacts[0].contact.updatedSource = updateDetails.updatedSource;

    // Contact Emails Payload
    this.contactEmails = [];

    if (
      this.workEmail?.email?.emailAddress?.length &&
      this.workEmail?.tempValue?.length == 0 &&
      this.workEmail.id > 0
    ) {
      this.workEmail.email.statusId = 3;
      this.contactEmails.push(this.workEmail);
    } else if (this.workEmail?.tempValue?.length) {
      this.workEmail.email.emailAddress = ParseHelper.DeepCopy(
        this.workEmail.tempValue
      );
      this.contactEmails.push(this.workEmail);
    }

    if (
      this.homeEmail?.email?.emailAddress?.length &&
      this.homeEmail?.tempValue?.length == 0 &&
      this.homeEmail.id > 0
    ) {
      this.homeEmail.email.statusId = 3;
      this.contactEmails.push(this.homeEmail);
    } else if (this.homeEmail?.tempValue?.length) {
      this.homeEmail.email.emailAddress = ParseHelper.DeepCopy(
        this.homeEmail.tempValue
      );
      this.contactEmails.push(this.homeEmail);
    }

    if (
      this.ce1?.email?.emailAddress?.length &&
      this.ce1?.tempValue?.length == 0 &&
      this.ce1.id > 0
    ) {
      this.ce1.email.statusId = 3;
      this.contactEmails.push(this.ce1);
    } else if (this.ce1?.tempValue?.length) {
      this.ce1.email.emailAddress = ParseHelper.DeepCopy(this.ce1.tempValue);
      this.contactEmails.push(this.ce1);
    }

    if (
      this.ce2?.email?.emailAddress?.length &&
      this.ce2?.tempValue?.length == 0 &&
      this.ce2.id > 0
    ) {
      this.contactEmails.push(this.ce2);
      this.ce2.email.statusId = 3;
    } else if (this.ce2?.tempValue?.length) {
      this.ce2.email.emailAddress = ParseHelper.DeepCopy(this.ce2.tempValue);
      this.contactEmails.push(this.ce2);
    }

    // Contact Phones Payload
    this.contactPhones = [];

    if (
      this.workPhone?.phone?.number?.length &&
      this.workPhone?.tempValue?.trim().length == 0 &&
      this.workPhone.id > 0
    ) {
      this.workPhone.phone.statusId = 3;
      this.contactPhones.push(this.workPhone);
    } else if (this.workPhone?.tempValue?.trim().length) {
      this.workPhone.phone.number = ParseHelper.DeepCopy(
        `${this.workPhone?.phone?.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(this.workPhone.tempValue)}`
      );
      this.contactPhones.push(this.workPhone);
    }

    if (
      this.homePhone?.phone?.number?.length &&
      this.homePhone?.tempValue?.trim().length == 0 &&
      this.homePhone.id > 0
    ) {
      this.homePhone.phone.statusId = 3;
      this.contactPhones.push(this.homePhone);
    } else if (this.homePhone?.tempValue?.trim().length) {
      this.homePhone.phone.number = ParseHelper.DeepCopy(
        `${this.homePhone?.phone?.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(this.homePhone.tempValue)}`
      );
      this.contactPhones.push(this.homePhone);
    }

    if (
      this.mobilePhone?.phone?.number?.length &&
      this.mobilePhone?.tempValue?.trim().length == 0 &&
      this.mobilePhone.id > 0
    ) {
      this.mobilePhone.phone.statusId = 3;
      this.contactPhones.push(this.mobilePhone);
    } else if (this.mobilePhone?.tempValue?.trim().length) {
      this.mobilePhone.phone.number = ParseHelper.DeepCopy(
        `${this.mobilePhone?.phone?.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(this.mobilePhone.tempValue)}`
      );
      this.contactPhones.push(this.mobilePhone);
    }

    if (
      this.cp1?.phone?.number?.length &&
      this.cp1?.tempValue?.trim().length == 0 &&
      this.cp1.id > 0
    ) {
      this.cp1.phone.statusId = 3;
      this.contactPhones.push(this.cp1);
    } else if (this.cp1?.tempValue?.trim().length) {
      this.cp1.phone.number = ParseHelper.DeepCopy(
        `${this.cp1?.phone?.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(this.cp1.tempValue)}`);
      this.contactPhones.push(this.cp1);
    }

    if (
      this.cp2?.phone?.number?.length &&
      this.cp2?.tempValue?.trim().length == 0 &&
      this.cp2.id > 0
    ) {
      this.contactPhones.push(this.cp2);
      this.cp2.phone.statusId = 3;
    } else if (this.cp2?.tempValue?.trim().length) {
      this.cp2.phone.number = ParseHelper.DeepCopy(
        `${this.cp2?.phone?.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(this.cp2.tempValue)}`
      );
      this.contactPhones.push(this.cp2);
    }

    // Contact Socials Payload
    this.contactSocials = [];

    if (
      this.contactFacebook?.socialProfile?.name?.length &&
      this.contactFacebook?.tempValue?.length == 0 &&
      this.contactFacebook.id > 0
    ) {
      this.contactFacebook.socialProfile.statusId = 3;
      this.contactSocials.push(this.contactFacebook);
    } else if (this.contactFacebook?.tempValue?.length) {
      this.contactFacebook.socialProfile.name = ParseHelper.DeepCopy(
        this.contactFacebook.tempValue
      );
      this.contactSocials.push(this.contactFacebook);
    }

    if (
      this.contactTwitter?.socialProfile?.name?.length &&
      this.contactTwitter?.tempValue?.length == 0 &&
      this.contactTwitter.id > 0
    ) {
      this.contactTwitter.socialProfile.statusId = 3;
      this.contactSocials.push(this.contactTwitter);
    } else if (this.contactTwitter?.tempValue?.length) {
      this.contactTwitter.socialProfile.name = ParseHelper.DeepCopy(
        this.contactTwitter.tempValue
      );
      this.contactSocials.push(this.contactTwitter);
    }

    if (
      this.contactLinkedin?.socialProfile?.name?.length &&
      this.contactLinkedin?.tempValue?.length == 0 &&
      this.contactLinkedin.id > 0
    ) {
      this.contactLinkedin.socialProfile.statusId = 3;
      this.contactSocials.push(this.contactLinkedin);
    } else if (this.contactLinkedin?.tempValue?.length) {
      this.contactLinkedin.socialProfile.name = ParseHelper.DeepCopy(
        this.contactLinkedin.tempValue
      );
      this.contactSocials.push(this.contactLinkedin);
    }

    if (
      this.contactInstagram?.socialProfile?.name?.length &&
      this.contactInstagram?.tempValue?.length == 0 &&
      this.contactInstagram.id > 0
    ) {
      this.contactInstagram.socialProfile.statusId = 3;
      this.contactSocials.push(this.contactInstagram);
    } else if (this.contactInstagram?.tempValue?.length) {
      this.contactInstagram.socialProfile.name = ParseHelper.DeepCopy(
        this.contactInstagram.tempValue
      );
      this.contactSocials.push(this.contactInstagram);
    }

    if (
      this.contactWebsite?.socialProfile?.name?.length &&
      this.contactWebsite?.tempValue?.length == 0 &&
      this.contactWebsite.id > 0
    ) {
      this.contactWebsite.socialProfile.statusId = 3;
      this.contactSocials.push(this.contactWebsite);
    } else if (this.contactWebsite?.tempValue?.length) {
      this.contactWebsite.socialProfile.name = ParseHelper.DeepCopy(
        this.contactWebsite.tempValue
      );
      this.contactSocials.push(this.contactWebsite);
    }

    if (leadContacts[0].contact.salutation) {
      leadContacts[0].contact.salutation.organizationId =
        this.app.user.organizationId;
    }

    leadContacts[0].contact.contactEmails = this.contactEmails;
    leadContacts[0].contact.contactPhones = this.contactPhones;
    leadContacts[0].contact.contactSocialProfiles = this.contactSocials;

    if (
      !leadContacts[0].contact?.contactSocialProfiles &&
      !leadContacts[0].contact.contactPhones &&
      !leadContacts[0].contact.contactEmails &&
      !leadContacts[0].contact.title &&
      !leadContacts[0].contact.firstName &&
      !leadContacts[0].contact.lastName
    ) {
      return null;
    }
    return leadContacts;
  }

  getLeadTypes(selectedLeadTypes, leadTypes = [], leadId = 0) {
    leadTypes = leadTypes || [];
    if (!selectedLeadTypes) {
      return null;
    }
    return selectedLeadTypes.map((type) => {
      const index = leadTypes.findIndex((data) => data.type.id === type.id);
      if (index !== -1) {
        return {
          ...leadTypes[index],
        };
      }
      return {
        id: 0,
        typeId: type.id,
        statusId: type?.statusId || 1,
        leadId: leadId || 0,
        createdSource: type?.createdSource || this.app.userIP,
        createdBy: type?.createdBy || this.app.user.userId,
        createdDate: type?.createdDate || new Date(),
      };
    });
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      '.ng-invalid[formControlName]'
    );
    this.scrollTo(firstElementWithError);

    if (!firstElementWithError) {
      const secondElementWithError = document.querySelector('.p-invalid');
      this.scrollTo(secondElementWithError);
    }
  }

  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  _updateCrudStateData() {
    if (this.crudType) {
      switch (this.crudType) {
        case 'add':
          this.headerTitle = 'Add New Lead';
          this.showAddAccount();
          this.selectedLead = {};
          break;
        case 'update':
          this.headerTitle = 'Edit Lead';
          this.isEditAccount = true;
          this.isSequenceNumberFeild = true;
          this.showEditAccount();
          break;
        case 'view':
          this.headerTitle = 'View Lead';
          this.prepareLeadViewUI();
          this.app.objectId = this.selectedLead?.id; //show activity
          this.app.objectType = ObjectNames.LEAD;
          this.isEditAccount = false;
          this.showEditAccount();
          this.leadForm?.disable();
          break;
        case 'copy':
          this.headerTitle = 'Copy Lead';
          this.isEditAccount = true;
          this.generateSequenceNumber();
          this.showEditAccount();
        default:
          break;
      }
    }
  }

  prepareLeadForm(data?) {
    this.leadForm = this.FormBuilder.group({
      id: data?.id || 0,
      typeId: data?.typeId || 0,
      description: data?.description || '',
      sequenceNumber: [{value: data?.sequenceNumber || '', disabled: true}],
      businessName: [
        data?.businessName || '',
        [Validators.maxLength(100), Validators.pattern('^[^:]*$')],
      ],
      ownerId: [],
      assignedToUserId: [data?.assignedToUserId || null],
      leadNumber: [data?.leadNumber || '', [Validators.maxLength(50)]],
      currencyId: data?.currencyId?.id || null,
      timeZoneId: data?.timeZoneId || null,
      taxId: [data?.taxId || null, [Validators.maxLength(50)]],
      name: data?.name || data?.businessName,
      leadTypes: [null],
      selectedLeadTypes: [this.defaultLeadType],
      isConvertedToAccount: false,
      organizationId: data?.organizationId || this.app.user.organizationId,
      leadId: data?.leadId || null,
      doingBusinessAs: [
        data?.doingBusinessAs || '',
        [Validators.maxLength(50)],
      ],
      branchId: data?.branchId || '',
      sourceId: data?.sourceId || this.defaultLeadSource?.id || null,
      paymentTerm: data?.paymentTerm || '',
      paymentMethod: data?.paymentMethod || '',
      storePicture: data?.storePicture || '',
      industryId: data?.industry?.id || null,
      annualRevenueId: data?.annualRevenue?.id || null,
      ratingId: data?.ratingId || this.defaultRating?.id || null,
      employeesRangeId: data?.employeesRange?.id || null,
      tickerSymbol: data?.tickerSymbol || '',
      leadStageId: data?.leadStageId || null,
      stageOwnerId: data?.stageOwnerId || null,
      comment: data?.comment || null,
      stageName: data?.stageName || '',
      gstNo: data?.gstNo || '',
      panNo: data?.panNo || '',
      leadStatusId: data?.leadStatusId || null,
      totalBalance: data?.totalBalance || 0,
      stageColor: data?.stageColor || '',
      statusId: data?.statusId || 1,
      isValid: data?.isValid || true,
      validFrom: data?.validFrom || null,
      validTo: data?.validTo || null,
      websiteURL: [data?.websiteURL || '', [Validators.maxLength(100)]],
      webTechnologies: data?.webTechnologies || '',
      facebookPage: [data?.facebookPage || '', [Validators.maxLength(100)]],
      linkedinPage: [data?.linkedinPage || '', [Validators.maxLength(100)]],
      twitterPage: [data?.twitterPage || '', [Validators.maxLength(100)]],
      instagramPage: [data?.instagramPage || '', [Validators.maxLength(100)]],
      sicCode: data?.sicCode || null,
      naicsCode: data?.naicsCode || null,
      foundedYearId: data?.foundedYearId || null,
      leadContacts: this.FormBuilder.array([this.getNewContact()]),
      createdSource: data?.createdSource || this.app.userIP,
      createdBy: data?.createdBy || this.app.user.userId,
      number: data?.number || 0,
      ownerShipType: [data?.ownership || this.defaultOwnership || 0],
      annualRevenue: this.defaultRevenue || '',
      employeesRange: [this.defaultEmployeesCount || ''],
      industry: [this.defaultIndustry || ''],
      foundedYear: [data?.foundedYear || null, [Validators.maxLength(15)]],
      leadTargetLists: [''],
      customAttributeValues: this.FormBuilder.array(
        this.newCustomAttributes([])
      ),
      updatedBy: [null],
      updatedDate: [null],
      updatedSource: [null],
    }) as FormGroup;

    if (!this.isEditAccount && !this.isAdd) {
      this.leadForm.disable();
    }
  }

  get formControl(): any {
    const account: FormArray = this.leadForm?.controls
      .leadContacts as FormArray;
    const address: FormArray = this.leadForm?.controls
      .leadAddresses as FormArray;
    return {
      contactEmailsArray: (<FormArray>(
        account?.controls[0]?.get('contact')?.get('contactEmails')
      )) as FormArray,
      contactPhonesArray: (<FormArray>(
        account?.controls[0]?.get('contact')?.get('contactPhones')
      )) as FormArray,
      contact: <FormGroup>account?.controls[0]?.get('contact'),
      firstName: <FormGroup>(
        account?.controls[0]?.get('contact')?.get('firstName')
      ),
      lastName: <FormGroup>(
        account?.controls[0]?.get('contact')?.get('lastName')
      ),
      leadContacts: (<FormArray>account) as FormArray,
      leadAddresses: (<FormArray>address) as FormArray,
      firstAddress: <FormGroup>address?.controls[0]?.get('address'),
      bus: <FormGroup>account?.controls[0]?.get('contact')?.get('lastName'),
      leadContactControls: (<AbstractControl>(
        account?.controls[0]
      )) as AbstractControl,
      leadStageId: <FormGroup>this.leadForm?.get('leadStageId'),
      contactSocialProfilesArray: (<FormArray>(
        account?.controls[0]?.get('contact')?.get('contactSocialProfiles')
      )) as FormArray,
    };
  }

  getNewContact() {
    const contactModel = this.getAccountContactsModel();
    return this.FormBuilder.group(contactModel);
  }

  newAccountSocialProfiles(
    socialProfileType?,
    socialProfileTypeId?
  ): FormGroup {
    return this.FormBuilder.group({
      leadId: [0],
      createdSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      createdDate: [new Date()],
      socialProfileId: [0],
      id: [0],
      updatedBy: [null],
      updatedDate: [null],
      updatedSource: [null],
      socialProfile: this.FormBuilder.group({
        socialProfileType: socialProfileType || {},
        name: ['', [Validators.maxLength(100)]],
        description: [''],
        createdSource: [this.app.userIP],
        createdBy: [this.app.user.userId],
        createdDate: [new Date()],
        socialProfileTypeId: socialProfileTypeId,
        id: [0],
        status: [],
        statusId: [1],
        updatedBy: [null],
        updatedDate: [null],
        updatedSource: [null],
      }),
    });
  }

  newAccountPhones(phoneType?, phoneTypeId?): FormGroup {
    return this.FormBuilder.group({
      leadId: [0],
      createdSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      createdDate: [new Date()],
      phoneId: [0],
      id: [0],
      updatedBy: [null],
      updatedDate: [null],
      updatedSource: [null],
      phone: this.FormBuilder.group({
        phoneType: phoneType || {},
        number: [''],
        extension: [''],
        createdSource: [this.app.userIP],
        createdBy: [this.app.user.userId],
        createdDate: [new Date()],
        phoneTypeId: phoneTypeId,
        id: [0],
        status: [],
        statusId: [1],
        updatedBy: [null],
        updatedDate: [null],
        updatedSource: [null],
      }),
    });
  }

  getAccountContactsModel() {
    return (() => {
      return {
        id: [0],
        createdSource: [this.app.userIP],
        createdBy: [this.app.user.userId],
        createdDate: [new Date()],
        updatedBy: [null],
        updatedDate: [null],
        updatedSource: [null],
        leadId: [0],
        contactId: [0],
        contact: this.FormBuilder.group({
          id: [0],
          createdSource: [this.app.userIP],
          createdBy: [this.app.user.userId],
          organizationId: [this.app.user.organizationId],
          createdDate: [new Date()],
          emailAddress: [],
          contactType: [],
          contactAssociationType: [this.selectedContactAssociationType || null],
          associationId: 0,
          associationName: [],
          salutationId: [this.defaultSalutation?.id],
          firstName: [
            '',
            [
              Validators.required,
              Validators.maxLength(100),
              Validators.pattern('^[^:]*$'),
            ],
          ],
          middleName: [
            '',
            [Validators.maxLength(100), Validators.pattern('^[^:]*$')],
          ],
          lastName: [
            '',
            [Validators.maxLength(100), Validators.pattern('^[^:]*$')],
          ],
          title: [''],
          gender: [],
          department: [],
          dateOfBirth: [''],
          contactSpokenLanguages: [],
          selectedContactSpokenLanguages: [],
          startDate: [''],
          jobFunction: [''],
          relationshipStatus: [],
          maritalStatus: [],
          source: [],
          annualIncome: [],
          education: [],
          fieldOfStudy: [],
          reportsTo: [],
          seniority: [],
          assistant: [],
          assistantPhone: [],
          sourceId: [null],
          isPrimaryContact: [true],
          businessCardPhoto: [''],
          profileImage: [''],
          description: [''],
          isActive: [''],
          statusId: [1],
          updatedBy: [null],
          updatedDate: [null],
          updatedSource: [null],
          degree: [null],
          contactRoleId: [this.defaultContactRole?.id||null],
          contactRoles : [this.defaultNewContactRole || null],
          customAttributeValues: this.FormBuilder.array(
            this.newCustomAttributes([])
          ),
        }),
      };
    })();
  }

  newContactEmails(emailType?, emailTypeId?): FormGroup {
    return this.FormBuilder.group({
      contactId: [0],
      createdSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      createdDate: [new Date()],
      emailId: [0],
      id: [0],
      updatedBy: [null],
      updatedDate: [null],
      updatedSource: [null],
      email: this.FormBuilder.group({
        createdSource: [this.app.userIP],
        createdBy: [this.app.user.userId],
        createdDate: [new Date()],
        description: [''],
        emailAddress: ['', [Validators.email, emailValidator]],
        emailType: emailType || {},
        emailTypeId: emailTypeId,
        id: [0],
        status: [],
        statusId: [1],
        updatedBy: [null],
        updatedDate: [null],
        updatedSource: [null],
      }),
    });
  }

  contactEmailCheck(emailDetails: any, formModel: any) {
    const emailAddress = emailDetails.tempValue;
    setTimeout(() => {
      if (
        formModel?.invalid ||
        !emailAddress ||
        !this.currentDisplay ||
        this.isSubmitted
      )
        return;

      this.contactService
        .contactEmailValidation(
          emailAddress,
          CONTACT_ASSOCIATION_ID.LEAD,
          emailDetails?.contactId
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (response) => {
            if (!response) {
              this.confirmationService.confirm({
                message: `${emailAddress} email already used in a contact, do you want to use it again?`,
                header: 'Email Already Used',
                icon: 'pi pi-exclamation-triangle',
                rejectLabel: 'Clear',
                acceptLabel: 'Yes',
                accept: () => {},
                reject: (type) => {
                  if (type == ConfirmEventType.REJECT)
                    emailDetails.tempValue = '';
                },
              });
            }
          },
          error: (error) => {},
        });
    }, 400);
  }

  newContactPhones(phoneType?, phoneTypeId?): FormGroup {
    return this.FormBuilder.group({
      contactId: [0],
      createdSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      createdDate: [new Date()],
      phoneId: [0],
      id: [0],
      updatedBy: [null],
      updatedDate: [null],
      updatedSource: [null],
      phone: this.FormBuilder.group({
        phoneType: phoneType || {},
        number: [''],
        extension: [''],
        createdSource: [this.app.userIP],
        createdBy: [this.app.user.userId],
        createdDate: [new Date()],
        phoneTypeId: phoneTypeId,
        id: [0],
        status: [],
        statusId: [1],
        updatedBy: [null],
        updatedDate: [null],
        updatedSource: [null],
      }),
    });
  }

  newContactSocialProfiles(
    socialProfileType?,
    socialProfileTypeId?
  ): FormGroup {
    return this.FormBuilder.group({
      contactId: [0],
      createdSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      createdDate: [new Date()],
      socialProfileId: [0],
      id: [0],
      updatedBy: [null],
      updatedDate: [null],
      updatedSource: [null],
      socialProfile: this.FormBuilder.group({
        socialProfileType: socialProfileType || {},
        name: [''],
        description: [''],
        createdSource: [this.app.userIP],
        createdBy: [this.app.user.userId],
        createdDate: [new Date()],
        socialProfileTypeId: socialProfileTypeId,
        id: [0],
        status: [],
        statusId: [1],
        updatedBy: [null],
        updatedDate: [null],
        updatedSource: [null],
      }),
    });
  }

  newAccountEmails(emailType?, emailTypeId?): FormGroup {
    return this.FormBuilder.group({
      leadId: [0],
      createdSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      createdDate: [new Date()],
      emailId: [0],
      id: [0],
      updatedBy: [null],
      updatedDate: [null],
      updatedSource: [null],
      email: this.FormBuilder.group({
        createdSource: [this.app.userIP],
        createdBy: [this.app.user.userId],
        createdDate: [new Date()],
        description: [''],
        emailAddress: ['', [Validators.email, emailValidator]],
        emailType: emailType || {},
        emailTypeId: emailTypeId,
        id: [0],
        status: [],
        statusId: [1],
        updatedBy: [null],
        updatedDate: [null],
        updatedSource: [null],
      }),
    });
  }

  newCustomAttributes(account_info) {
    if (!account_info || account_info.length == 0) return [];
    let customAttibutesArray = [];
    account_info.forEach((element) => {
      if (element.isDelete) {
        customAttibutesArray.push(this.newCustomAttribute(element));
      }
    });
    return customAttibutesArray;
  }

  newCustomAttribute(control): FormGroup {
    return this.FormBuilder.group(this.createFormField(control));
  }

  createFormField(control) {
    return {
      id: 0,
      createdSource: 'string',
      updatedSource: 'string',
      createdBy: 0,
      updatedBy: 0,
      createdDate: new Date(),
      updatedDate: new Date(),
      objectId: this.objectId,
      objectValue: 0,
      customAttributeId: control.id,
      customAttribute: control,
      value:
        control.isRequired &&
        (control.formControl.name == 'InputBox' ||
          control.formControl.name == 'RadioButton' ||
          control.formControl.name == 'DatePicker')
          ? ['', Validators.required]
          : '',
      values:
        control.isRequired && control.formControl.name == 'DropDownList'
          ? [null, Validators.required]
          : null,
      multipleValues:
        control.isRequired && control.formControl.name == 'MultipleDropDownList'
          ? [null, Validators.required]
          : null,
      multipleCheckBox:
        control.isRequired && control.formControl.name == 'CheckBox'
          ? [null, Validators.required]
          : null,
      customeAttachement:
        control.isRequired && control.formControl.name == 'FileUpload'
          ? [null, Validators.required]
          : null,
      ratingId:
        control.isRequired && control.formControl.name == 'Rating'
          ? [0, Validators.required]
          : 0,
      toggle:
        control.isRequired && control.formControl.name == 'ToggleButton'
          ? [false, Validators.required]
          : false,
      statusId: 1,
    };
  }

  createEmptyFormField(control) {
    return {
      id: 0,
      createdSource: 'string',
      updatedSource: 'string',
      createdBy: 0,
      updatedBy: 0,
      createdDate: new Date(),
      updatedDate: new Date(),
      objectId: this.objectId,
      objectValue: 0,
      customAttributeId: control.id,
      customAttribute: control,
      value:
        control.formControl.name == 'InputBox' ||
        control.formControl.name == 'RadioButton' ||
        control.formControl.name == 'DatePicker'
          ? ''
          : '',
      values: control.formControl.name == 'DropDownList' ? null : null,
      multipleValues:
        control.formControl.name == 'MultipleDropDownList' ? null : null,
      multipleCheckBox: control.formControl.name == 'CheckBox' ? null : null,
      customeAttachement:
        control.formControl.name == 'FileUpload' ? null : null,
      ratingId: control.formControl.name == 'Rating' ? 0 : 0,
      toggle: control.formControl.name == 'ToggleButton' ? false : false,
      statusId: 1,
    };
  }

  /* New Implementation Starts */
  getTemplateFormFields(channelId: number) {
    // this.currentDisplay = false;
    this.checkedFields = null;
    this.appMainService.isShowSpinner('getTemplateFormFields');
    this.sharedConfigService
      .getTemplateFormFields(this.leadModuleId, channelId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.templateSections = response || [];
          this.generateCheckedFields();
          this.generateLeadInfoCustomFields();
          this.generateLeadDetailsCustomFields();
          this.prepareCustomSectionFields();
        },
        error: () => {
          this.templateSections = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to load Template under this Channel',
          });
        },
        complete: () => {
          this.currentDisplay = true;
          this.appMainService.isHideSpinner('getTemplateFormFields');
        },
      });
  }

  generateLeadInfoCustomFields() {
    const customAttributeValues =
      this.selectedLead?.customAttributeValues || [];
    const sectionCustomFields = this.templateSections[1]?.customFields || [];
    const data = this.customAttributeService.generateCustomFieldValues(
      'Lead',
      'Information',
      customAttributeValues,
      sectionCustomFields
    );
    this.leadInfoCustomFields = data.customFields;
    this.leadInfoCustomValues = data.customValues;
  }

  generateLeadDetailsCustomFields() {
    const customAttributeValues =
      this.selectedLead?.customAttributeValues || [];
    const sectionCustomFields = this.templateSections[2]?.customFields || [];
    const data = this.customAttributeService.generateCustomFieldValues(
      'Lead',
      'Details',
      customAttributeValues,
      sectionCustomFields
    );
    this.leadDetailsCustomFields = data.customFields;
    this.leadDetailsCustomValues = data.customValues;
  }

    /** Custom Section */

    prepareCustomSectionFields() {
        const customAttributeValues = this.selectedLead?.customAttributeValues || [];
        this.customSections = this.templateSections.filter(section=> section && section?.systemGenerated == false && section?.customFields && section?.customFields?.length > 0);
        this.customSectionsForView = [];
        this.customSectionFields = [];
        this.customSectionValues = [];

        for(let section of this.customSections){
          const sectionCustomFields = section?.customFields || [];
          if(sectionCustomFields.length > 0){
            const data = this.customAttributeService.generateCustomFieldValues('Lead', 'Custom Section', customAttributeValues, sectionCustomFields);
            if(data.customFields && data.customFields.length > 0 && data.customValues && data.customValues.length > 0){
              this.customSectionsForView.push(section);
            }
            this.customSectionFields.push(data.customFields);
            this.customSectionValues.push(data.customValues);
          } else {
            this.customSectionFields.push(null);
            this.customSectionValues.push(null);
          }
        }
    }

  // Generate the checkedFields object to show/hide form control fields in the form
  generateCheckedFields() {
    this.checkedFields = {};

    for (const { name, fields } of this.templateSections) {
      for (const fieldData of fields) {
        if (fieldData.name) {
          if (fieldData.childFields?.length) {
            fieldData.name = this.leadHelper.processFieldName(fieldData.name);

            this.checkedFields[fieldData.name] = {
              labelName: fieldData.labelName,
            };

            for (const childFieldData of fieldData.childFields) {
              childFieldData.name = this.leadHelper.processFieldName(
                childFieldData.name
              );

              if (
                name === Sections.CONTACT_DETAILS &&
                fieldData.name === 'SocialProfile'
              ) {
                childFieldData.name = 'Contact' + childFieldData.name;
              } else if (
                name === Sections.LEAD_DETAILS &&
                fieldData.name === 'LeadSocial'
              ) {
                childFieldData.name = 'Lead' + childFieldData.name;
              }

              this.checkedFields[childFieldData.name] = {
                labelName: childFieldData.labelName,
              };
            }
          } else {
            fieldData.name = this.leadHelper.processFieldName(fieldData.name);

            if (
              fieldData.name == 'LeadEmail' ||
              fieldData.name == 'LeadPhone'
            ) {
              continue;
            }

            this.checkedFields[fieldData.name] = {
              labelName: fieldData.labelName,
            };
          }
        }
      }
    }
  }

  prepareLeadViewUI(): void {
    this.viewLeadData = this.selectedLead
      ? this.leadHelper.processViewData(this.selectedLead)
      : null;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  //#region Component Split Codes

  async showEditLead() {
    this.selectedLead = null;
    this.tabIndex = 0;
    await this.getLeadDetails(this.selectedLeadId);
    this.crudType === 'update' && (await this.getLeadAddUpdateData());
    this.crudType === 'copy' && (await this.getLeadAddUpdateData());
    this.crudType === 'add' && (await this.getLeadAddUpdateData());
  }

  async getLeadDetails(leadId: number) {
    if (leadId > 0) {
      this.appMainService.isShowSpinner('showEditLead');
      this.detailsLoadingFailed = false;
      await this.leadService
        .getLeadById(leadId,true)
        .then((lead: Lead) => {
          this.appMainService.isHideSpinner('showEditLead');
          this.selectedLead = JSON.parse(JSON.stringify(lead));
          if (!this.selectedChannelId) {
            this.selectedChannelId = this.selectedLead.typeId;
          }
          if (!this.selectedLead?.leadContacts) {
            this.selectedLead.leadContacts = [];
          }
          this.preLeadpareCrud();
        })
        .catch((error) => {
          this.detailsLoadingFailed = true;
          this._updateCrudStateData();
          switch (error?.status) {
            case 404:
                this.detailsErrorMessage = "You're not permitted to view this lead details!";
                break;
            default:
                this.detailsErrorMessage = 'Error occurring when fetching lead details. Please try after sometimes.';
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: this.detailsErrorMessage,
                });
              break;
          }

          this.appMainService.isHideSpinner('showEditLead');
        });
    } else {
      this.preLeadpareCrud();
    }
  }

  async getLeadAddUpdateData() {
    this.activeUsers = this.app.usersList.filter((obj) => obj.statusId == 1);

    if (this.crudType == 'add' || this.crudType == 'copy') {
      const loggedInUserId =
        JSON.parse(localStorage.getItem('user'))?.userId || 0;
      const defaultUser = this.activeUsers.find(
        (user) => user.id === loggedInUserId
      );
      setTimeout(() => {
        this.isAdd && this.leadForm?.patchValue({ ownerId: defaultUser });
      });
    }

    this.contactHttpService.getContactRoles().subscribe((roles) => {
      this.contactRoles = roles.filter((el) => el.isActive);
      this.populateDefaultData();
    });

    this.leadService
      .getAllLeadTypes(TypeGroupIds.LeadTypeLeadAPI)
      .then((types) => {
        this.types = types.filter((el) => el.statusId === 1);
        this.populateDefaultData();
      });

    this.contactService.getAllContactAssociation().then((asso) => {
      const contactAssociations = asso;
      const data = contactAssociations.filter(({ name }) => name === 'Lead');
      this.selectedContactAssociationType = data.length > 0 ? data[0] : null;
    });

    this.leadService
      .getAllSources(this.app.user.organizationId)
      .then((sources) => {
        this.sources = sources.filter((el) => el.statusId === 1);
        this.populateDefaultData();
      });

    this.leadService
      .getAllLeadStatus(StatusGroupIds.LeadStatusGroupId)
      .then((statuses) => {
        this.status = statuses;
        this.populateDefaultData();
      });

    //Stage
    this.ruleService
      .getStageList(this.objectId, this.selectedChannelId, false)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((stages) => {
        if (stages) {
          this.stages = stages
            .filter((el) => el.id && el.id !== -1)
            .map((x) => ({ id: x.id, name: x.name, ownerId: x.ownerId }));
          this.selectedStage =
            this.stages.length > 0 ? this.stages[0] : this.selectedStage;
          this.getDefaultStage();
          // this.getSettingsData();
          this.populateDefaultData();
        }
      });

    this.getDropdownValues();
  }

  //#endregion

  //#region ***Dropdown List Loading***
  getDropdownValues(): void {
    this.loadContactRoles();
    this.loadSalutations();
    // this.loadAccountTypes();
    this.loadUsers();
    this.loadAccountSources();
    this.loadEmployeeCount();
    this.loadTimezones();
    this.loadCurrencies();
    this.loadRatings();
    this.loadAnnualRevenues();
    this.loadOwnerships();
    this.loadIndustries();
    this.loadCountries();
    // this.loadLanguages();
    this.loadAddressTypes();
    this.loadAddressClasses();
    this.loadTags();
    !this.employees?.length &&
      this.accountDataService.dispatchGettingAllStores();
    !this.salutations?.length &&
      this.sharedDataService.dispatchGettingAllStores();
  }

  loadUsers(): void {
    this.activeUsers = this.app.usersList.filter((obj) => obj.statusId == 1);
  }

  loadSalutations(): void {
    this.sharedDataService
      .loadSalutations()
      .pipe(
        map((salutations) => {
          this.salutations = salutations;
          this.populateDefaultData();
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  // loadAccountTypes(): void {
  //     this.accountDataService.loadAccountTypes()
  //         .pipe(map(accountTypes => {
  //             this.accountTypes = accountTypes;
  //         }), catchError(() => []))
  //         .subscribe();
  // }

  loadAccountSources(): void {
    this.sharedDataService
      .loadSources()
      .pipe(
        map((accountSources) => {
          this.sources = accountSources;
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadEmployeeCount(): void {
    this.accountDataService
      .loadEmployeeCounts()
      .pipe(
        map((employeeCount) => {
          this.employees = employeeCount;
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadTimezones(): void {
    this.accountDataService
      .loadTimezones()
      .pipe(
        map((timezones) => {
          this.timeZoneList = timezones || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadCurrencies(): void {
    this.importService.getOrgCurrency().subscribe(value=>{
      if(value){
        this.currencyList = value;
        const activeCurrencies = this.currencyList.filter(currency => currency?.statusId === 1);
        this.activeCurrencies = activeCurrencies;
          this.currencyList = activeCurrencies.map((el) => {
            return {
              id: el?.currencyId,
              name: `${el?.code} - ${el?.country?.name}`,
            };
          });
          this.populateDefaultData();
      }
    });
  }

  loadRatings(): void {
    this.accountDataService
      .loadRatings()
      .pipe(
        map((ratings) => {
          if (ratings) {
            this.ratings = ratings;
            this.populateDefaultData();
          }
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadAnnualRevenues(): void {
    this.accountDataService
      .loadAnnualRevenues()
      .pipe(
        map((revenues) => {
          this.revenues = revenues;
          this.populateDefaultData();
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadOwnerships(): void {
    this.accountDataService
      .loadOwnerships()
      .pipe(
        map((ownerships) => {
          this.ownerships = ownerships;
          this.populateDefaultData();
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadIndustries(): void {
    this.accountDataService
      .loadIndustries()
      .pipe(
        map((industries) => {
          this.industries = industries;
          this.populateDefaultData();
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadCountries(): void {
    this.sharedDataService
      .loadCountries()
      .pipe(
        map((countries) => {
          this.countries = countries || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  // loadLanguages(): void {
  //     this.sharedDataService.loadLanguages()
  //         .pipe(map(languages => {
  //             this. = languages || [];
  //         }), catchError(() => []))
  //         .subscribe();
  // }

  loadAddressTypes(): void {
    this.sharedDataService
      .loadAddressTypes()
      .pipe(
        map((addressTypes) => {
          this.accountAddressTypes =
            addressTypes?.filter((el) => el.isActive) || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadAddressClasses(): void {
    this.sharedDataService
      .loadAddressClasses()
      .pipe(
        map((addressClasses) => {
          this.addressClasses =
            addressClasses?.filter((el) => el.isActive) || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  //tags
  removeTag(i) {
    this.tags.splice(i, 1);
  }

  addTag() {
    this.displayAddTag = true;
    if (this.tags?.length > 0) {
      this.tags = JSON.parse(JSON.stringify(this.removeDuplicates(this.tags)));
      this.selectedValues = this.tags;
    }
  }

  removeDuplicates(arr: Tag[]): Tag[] {
    const uniqueSet = new Set();

    return arr.filter((obj) => {
      const objString = JSON.stringify(obj);
      if (!uniqueSet.has(objString)) {
        uniqueSet.add(objString);
        return true;
      }
      return false;
    });
  }


  loadTags() {
    this.leadServiceN
      .getAllTags()
      .pipe(
        tap((tags) => {
          const filteredTags = tags.filter((data) => data?.statusId == 1);
          this.tagList = JSON.parse(JSON.stringify(filteredTags));
        }),
        catchError(() => of([])),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe();
  }

  createTag(tag: Tag): void {
    this.leadServiceN
      .addTags(tag)
      .pipe(
        tap((tag: Tag) => {
          if (tag !== null) {
            this.loadTags();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Added Successfully...',
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Duplicate tag names are not allowed.',
            });
          }
          this.displayCreateTag = false;
        }),
        catchError(() => of(null)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe();
  }

  assignSelectedTags(tags: Tag[]) {
    if (tags.length > 0) {
      this.tags = JSON.parse(JSON.stringify(this.removeDuplicates(tags)));
    }
    this.displayAddTag = false;
  }

  // ------------stage owner work
  getSettingsData() {
    this.crmSettingsService.getCrmSettingFieldsList().subscribe({
      next: (response: CrmSettingModel[]) => {
        this.leadOwnerSettings = response?.find(data => data?.moduleId == LeadModuleId && data?.code == StageOnwerSettingCode?.leadOwnerSttingCode);
        if(this.leadOwnerSettings?.enabled){
          this.leadForm.patchValue({stageOwnerId:this.selectedOwnerStageDefault?.ownerId});
        }
      },
      error: (error) => { }
    });
  }

  getDefaultStage() {
    if (this.crudType == 'update') {
      this.selectedOwnerStageDefault = this.stages?.find(data => data?.id == this.selectedLead?.leadStageId);
    } else {
      this.selectedOwnerStageDefault = this.stages?.find(data => data?.name == this.selectedStage?.name && data?.id == this.selectedStage?.id);
    }
  }

  setStageOwnerAccordingToStage(value) {
    if (value) {
      let stageOwnerId;
      this.selectedOwnerStage = this.stages?.find(data => data?.id == value);
      // if (this.leadOwnerSettings?.enabled) {
      //   stageOwnerId = this.selectedOwnerStage?.ownerId || this.app?.user?.userId;
      // } else {
      //   stageOwnerId = this.selectedOwnerStage?.ownerId || null;
      // }
      // this.leadForm.patchValue({ stageOwnerId: stageOwnerId });
      if(this.selectedOwnerStageDefault?.id == value){
        this.stageCommentEnable = false;
        this.leadForm.patchValue({ comment: null });
      }else{
        this.stageCommentEnable =  true;
      }
    }
  }

  onSelectStageOwner(value){
    if(value){
      // this.stageCommentEnable = this.selectedOwnerStageDefault?.ownerId == value &&  this.selectedOwnerStage?.id == this.selectedOwnerStageDefault?.id ? false : true;
    }
  }


  getCountryCode(data?) {
    this.accountUserService.countryCode().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        {
          next: (response) => {
            this.countryData = response;
          },
          error: (error) => {
            this.appMainService.isHideSpinner('authenSetUp');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'please try again...'
            });

          },
          complete: () => { },
        });
  }

    onCountrySelect(event: any, phoneType: any) {
        const selectedCountry = this.countryData.find(item => item.CountryName === event.value);
        if (selectedCountry) {
            phoneType.phone.code = selectedCountry.PhoneCode;
            // phoneType.tempValue = null;
        }
    }

    async getPhoneNumberTemplate() {
        this.phoneNumberFormat = await this.phoneNumberFormatService.getPhoneNumberFormat();
    }

    populateNewContactRoles() {
      if (this.crudType === 'add') {
        this.defaultNewContactRole = this.newContactRoles.filter((el) => el.isDefault);
        const itemControls = <FormArray>this.leadForm?.controls['leadContacts'];
        const itemFormGroup = <FormGroup>itemControls?.controls[0];
        const contactGroup = <FormGroup>itemFormGroup?.controls['contact'];
        contactGroup?.controls['contactRoles']?.setValue(
          this.defaultNewContactRole || null
        );
      }
    }

    loadContactRoles(): void {
      this.appMainService.isShowSpinner('contactRoles');
      this.configurationService.getNewAllContactRoles().subscribe({
        next: (resp: any[]) => {
          this.newContactRoles = resp?.length ? resp.map((role)=>({
            id: 0, 
            roleId: role?.id,
            roleName: role?.name,
            isDefault: role?.isDefault,
          })): [];
          this.populateDefaultData();
          this.appMainService.isHideSpinner('contactRoles');
        },
        error: (err) => {
          this.appMainService.isHideSpinner('contactRoles');
        }
      });
    }
  //#endregion
}
